import React, {Component} from 'react';
import css from './CustomerDetails.module.scss';
import Accordion from "../../components/Accordion/Accordion";
import Progress from "../../components/Progress/Progress";
 import { faChevronDown, faChevronRight, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faEllipsisV, faCaretDown, faCaretUp, faCheck} from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import axios from 'axios';
import moment from 'moment';
import he from 'he';
import {connect} from "react-redux";
import formatShortDate from '../../utils/formatShortDate';
import replaceStageName from "../../utils/replaceStageName";
import replaceInternalStage from "../../utils/replaceInternalStage";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
import {Link} from "react-router-dom";
import ErrorLabel from "../../components/ErrorLabel/ErrorLabel";
import SurveyCalendar from "../SurveyCalendar/SurveyCalendar";
import InstallCalendar from "../InstallCalendar/InstallCalendar";
import _, { each } from 'lodash';
import {futureSurvey} from "../../helpers/timePeriods";
import getDateQry from "../../helpers/dateHelpers";
import { fetchS3Photos } from '../../utils/awsHelper';
import buildPicklistDependency from "../../utils/buildSfPicklistDependency";

/**
 * @class
 */
const CustomerDetails = class extends Component {
    // ---------- class fields: ----------
    customerId = this.props.match.params.id;

    source = axios.CancelToken.source();

    messageGroupTypes = [
        'Proposal',
        'Contract Work',
        'Customer Service',
        'Supervisor',
    ];

    // used to fetch progress stages and missing docs:
    postRequestOpportunity = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "CloseDate",
            "Internal_Stage__c",
            "StageName",
            "Type",
            "Post_System_Size__c",
            "Completed_Deal_Docs__c",
            "Sales_Representative__c",
            "Sales_Representative__r.Name",
            "Sales_Representative__r.Phone",
            "Sales_Representative_2__c",
            "Sales_Representative_2__r.Name",
            "Sales_Representative_2__r.Phone",
            "Sales_Representative_3__c",
            "Sales_Representative_3__r.Name",
            "Sales_Representative_3__r.Phone",
            "System_Size__c",
            "Deal_Documents__c",
            "Deal_Documents__r.Missing_Deal_Docs_for_Dashboard__c",
            "Deal_Documents__r.Credit_Checked__c",
            "Deal_Documents__r.Usage__c",
            "Deal_Documents__r.Title_Docs_Trust_Docs_Received__c",
            "Deal_Documents__r.Scheduled_SS__c",
            "Deal_Documents__r.Agreement_Signed__c",
            "Deal_Documents__r.Solar_Info_Packet__c",
            "Deal_Documents__r.Text_Out_Hold_Reason__c",
            "Deal_Documents__r.Text_out_hold_Recheck__c",
            "Deal_Documents__r.Deal_Docs_Verified__c",
            "Deal_Documents__r.Approval_Outcome__c",
            "Post_Appointment_Time__c",
            "Post_Appointment_Completed_DT__c",
            "Pending_Sale_Date__c",
            "Sub_Status_new__c",
            "Status__c",
            "Preferred_Escalator__c",
            "Cancel_Survey_Request__c",
            "Sales_Rep_1_Setter_Closer__c",
            "Sales_Rep_2_Setter_Closer__c",
            "Sales_Rep_3_Setter_Closer__c",
            "Location__c",
            "Location__r.Name",
            "Contact__r.Name",
            "Contact__r.Phone",
            "Contact__r.Secondary_Phone_for_contact__c",
            "Contact__r.Email",
            "Contact__r.Preferred_Communication__c",
            "Contact__r.Customer_Type__c",
            "Contact__c",
            "Co_Signer__c",
            "SS_Schedulable__c",
            "Jurisdiction_opp__c",
            "Jurisdiction_opp__r.Name",
            "Permit_Submitted__c",
            "Permit_Complete__c",
            "Sold_Deal_DateTime__c",
            "Sold_Deal_Date__c",
            "Electrical_Work__c",
            "Electrical_Work__r.Meter_Spot_Required__c",
            "Electrical_Work__r.Meter_Spot_Submitted__c",
            "Electrical_Work__r.Meter_Spot_Complete__c",
            "Active_Permit__r.HOA_Applied__c",
            "Active_Permit__r.HOA_Contact_Information__c"
        ],
        "where": {
            "Id": this.props.match.params.id
        }
    };

    postRequestAttempts = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Call_Outcome__c",
            "Customer_Name__c",
            "Notes__c",
            "Type__c",
            "Sales_Rep__c",
            "CreatedDate"
        ],
        "where": {
            "Opportunity_Name__c": this.props.match.params.id
        }
    };

    postRequestCase = {
        "limit": 25,
        "skip": 0,
        fields: [
            "Id",
            "Customer_Signature__c",
            "Following_Up_on_Signature__c",
            "Reason_for_New_Signature__c",
            "Signature_Received__c",
            "Post_OA__c",
            "Post_OA__r.Name",
            "Post_ETA__c",
            "Post_Completed_Date__c",
            "Office_Request_Disregarded_By_Rep__c",
            "isClosed",
            "Type",
            "Subject",
            "Description",
            "CreatedDate",

            // Option 1 fields
            "Option_1_Financier__c",
            "Option_1_Financing_Type__c",
            "Option_1_EPC__c",
            "Option_1_Monthly__c",
            "Option_1_Offset__c",
            "Option_1_Production__c",
            "Option_1_Rate__c",
            "Option_1_Escalator__c",
            "Option_1_Layout__c",
            "Option_1_Battery_Type__c",
            "Option_1_Battery_Quantity__c",
            "Option_1_Priorities__c",

            // Option 2 fields
            "Option_2_Financier__c",
            "Option_2_Financing_Type__c",
            "Option_2_EPC__c",
            "Option_2_Monthly__c",
            "Option_2_Offset__c",
            "Option_2_Production__c",
            "Option_2_Rate__c",
            "Option_2_Escalator__c",
            "Option_2_Layout__c",
            "Option_2_Battery_Type__c",
            "Option_2_Battery_Quantity__c",
            "Option_2_Priorities__c",

            // Option 3 fields
            "Option_3_Financier__c",
            "Option_3_Financing_Type__c",
            "Option_3_EPC__c",
            "Option_3_Monthly__c",
            "Option_3_Offset__c",
            "Option_3_Production__c",
            "Option_3_Rate__c",
            "Option_3_Escalator__c",
            "Option_3_Layout__c",
            "Option_3_Battery_Type__c",
            "Option_3_Battery_Quantity__c",
            "Option_3_Priorities__c"
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id, // related to this opportunity
            "Type": 'Office Request'
        },
        "orderBy": {
            "CreatedDate": "DESC"
        }
    };

    postRequestTask = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Subject",
            "Owner.Name",
            "Owner.Type",
            "Completion_Date__c",
            "Conclusion__c",
            "Type",
            "Description",
            "CreatedDate"
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id, // related to this opportunity
            "Type": 'Office Request'
        },
        "orderBy": {
            "CreatedDate": "DESC"
        }
    };

    postRequestChatter = {
        "recordIds": [this.props.match.params.id]
    };

    postSchedSurvey = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Opportunity__c",
            "Date__c",
            "Start_Time__c"
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id,
            "Cancel_Date_Time__c": null,
            "Work_Types__c": 'Site Survey'
        },
        "date": {
            ...getDateQry(futureSurvey, 'Date__c')
        }
    };

    postRequestSurveySess = {
        "limit": 100,
        "skip": 0,
        "fields": [
            "Id",
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id,
            "Site_Survey_Outcome2__c": null,
            "RecordTypeId": '0121N000001LzeE'
        }
    };

    postRequestProposals = () => {
        const opp = this.state.opportunity;

        return {
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Price_per_Watt__c",
                "Price_per_kWh__c",
                "Est_Year_One_Production__c",
                "System_Size__c",
                "EPC__c",
                "Annual_Usage__c",
                "Escalator__c",
                "Production_Ratio__c",
                "Monthly_Bill_Amount__c",
                "RecordTypeId",
                "Battery_Type__c",
                "Battery_Type__r.Name",
                "Number_of_Batteries__c",
                "Monthly_Battery_Amount__c",
                "Total_Monthly_Payment__c",
                "Type__c",
                "Financing_Partner__c",
                "Amount__c",
                "Proposal_Stage__c",
                "Active__c",
                "Proposal_Complete__c",
                "Deal_Documents__r.Missing_Deal_Docs_for_Dashboard__c",
                "Proposal_Adders__c",
                "Proposal_Notes_to_Rep__c",
                "CreatedBy.Name",
                "Ground_Mount__c",
                "Ground_Mount_Under_9kW__c",
                "Carport__c",
                "Trenching_Concrete_Color_Match__c",
                "Trenching_Concrete_No_Color_Match__c",
                "Feet_of_Trenching_Dirt__c",
                "Reroof__c",
                "Partial_Reroof__c",
                "Full_Reroof__c",
                "Partial_Reroof_Arrays__c",
                "Proposal_Naming_Details__c",
                "CreatedDate",
                "Conduit_run_through_attic__c",
                "Pool_Solar_Removal__c",
                "Powerwashing__c",
                "Number_of_Arrays__c",
                "Contract__c",
                "Post_Panel_Count__c",
                "Offset__c",
                "Don_t_Use__c"
            ],
            "where": {
                // either is related to opportunity or is in opportunity's active prelim/post lookup.
                "$or": [
                    {
                        "$and": [
                            { "Opportunity__c": opp.Id },
                            { "Opportunity__c": { "$ne": null } }
                        ]
                    },
                    {
                        "Id" : {"$in" : [opp.Active_Prelim_Proposal__c, opp.Active_Post_Proposal__c]}
                    }
                ]
            },
            "sort": [{"CreatedDate": "DESC"}]
        }
    }

    postRequestRetention = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Cancellation_Reason__c",
            "Cancellation_Sub_Reason__c"
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id,
            "RecordTypeId": "012Ug000000028HIAQ" // "Cancel Pending" recordType
        },
        "sort": [{"CreatedDate": "DESC"}]
    }

    postRequestAccountManagement = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Assigned_Account_Manager__r.Name",
            "Assigned_Account_Manager__r.Sales_Rep_Account__r.Email__c",
            "Next_Step__c",
            "Action_Required__c",
            "Rep_Action_Requested__c",
            "Rep_Action_Resolved__c"
        ],
        "where": {
            "Opportunity__c": this.props.match.params.id
        }
    }

    prioritiesOptions = ['Financier', 'EPC', 'Monthly', 'Offset/Production', 'Rate', 'Escalator', 'Battery Type'];
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
    SF_DATE_FORMAT = "YYYY-MM-DD";

    // ---------- state: ----------
    state = {
        isModelOpen: false,
        logAttemptNotes: '',
        logAttemptType: '',
        logAttemptOutcome: '',
        isEditingCustomer: false,
        opportunity: {},
        missingDocs: [],
        progressStages: [],
        currentStageIndex: 0,
        attempts: [],
        chatter: [],
        postAppointmentTime: '',
        postAppointmentCompleted: '',
        cancelSurveyRequest: '',
        rep1SetterCloser: '',
        rep2SetterCloser: '',
        rep3SetterCloser: '',
        customerTypeOld: [],
        customerType: [],
        customerTypeOptions: [],
        nextStep: '',
        shouldShowCalendar: false,
        shouldShowInstallCalendar: false,
        isPostModalOpen: false,
        isPropRevModalOpen: false,
        postRequestTask: {},
        postFinancier: '',
        postPricingMethod: '',
        pricingMethodAmmount: '',
        postOffset: '',
        batteryUse: '',
        batteryQuant: '',
        postEscalator: '',
        postNotes: '',
        customerName: '',
        customerPhone: '',
        customerPhone2: '',
        customerPreferredEmail: '',
        customerPreferredCommunication: '',
        financingPartners: [],
        financingTypes: [],
        productOptions: [
            {value : 'Ez-Own'},
            {value : 'Ez-Own + Battery'},
            {value : 'PPA'},
            {value : 'PPA + Battery'},
            {value : 'Cash'},
            {value : 'Retrofit'},
        ],
        rateOptions: [
            {value : '13'},
            {value : '13.5'},
            {value : '14'},
            {value : '14.5'},
            {value : '15'},
            {value : '15.5'},
            {value : '16'},
            {value : '16.5'},
            {value : '17'},
            {value : '17.5'},
            {value : '18'},
            {value : '18.5'},
            {value : '19'},
            {value : '19.5'},
            {value : '20'},
            {value : '20.5'},
            {value : '21'},
            {value : '21.5'},
            {value : '22'},
            {value : '22.5'},
            {value : '23'},
            {value : '23.5'},
            {value : '24'},
            {value : '24.5'},
            {value : '25'},
            {value : '25.5'},
            {value : '26'},
            {value : '26.5'},
            {value : '27'},
            {value : '27.5'},
            {value : '28'},
            {value : '28.5'},
        ],
        postError: '',
        disableSubmit: false,
        revDescription: '',
        revPostRequestDate: '',
        revOffset: '',
        revRate: '',
        revEPC: '',
        revMonthly: '',
        revLayout: '',
        revPriority: '',
        revNotes: '',
        revCreateFail: false,
        disableRevButton: false,
        contract: {},
        primaryOppContact: {},
        salesRepContact: {},
        agreementConfirm: false,
        scheduledSurveys: [],
        showCancelSurvey: true,
        showPostProp: false,
        showOfficeRequests: false,
        visibleOfficeRequests: [],
        tempSurveyCancelId: '',
        disableCancelSurvey: false,
        errorCancelSurvey: '',
        patError: false,
        patWarning: false,
        patErrorMessage: '',
        prelimProp: {},
        postProp: {},
        dealDoc: new Map(),
        disableInstall: true,
        numInstallDays: "1",
        installErrorNotes: '',
        installErrorModal: false,
        texasLocation: false,
        disablePricingButton: true,
        pricingModalOpen: false,
        pricingMethod: '',
        displayedPPW: 0,
        displayedKWH: 0,
        monthlyBill: 0,
        prodRatioCheck: 0,
        ppw: 0,
        kwh: 0,
        proposalType: '',
        kwhError: '',
        ppwError: '',
        pricingData: [],
        emptyMatrixError: '',
        agreementModal: false,
        newContract: {},
        repIdForContract: '',
        contractReps: [],
        sendAgreementDisabled: false,
        creatingContract: false,
        visiblePostProposals: [], // post proposals visible for sales rep on the page

        retentionModal:false,
        retentionNotes: '',
        oppNotes: '',
        oppNotesDisabled: false,
        oppNoteSaveSuccess: false,

        isCancelPendingModalOpen: false,
        reason: '',
        subReason: '',
        reasonSpecific: '',
        disableCancelPending: false,
        cancelReasons: [],
        cancelSubReasons: [],
        cancelSubReasonsMap: {}, // cancel sub reason is a dependent field, this is a map of cancel reason to a list of sub reasons

        visibleCancelReason: '',
        visibleCancelSubReason: '',

        ewMeterSpotRqd: '',
        ewMeterSpotSub: '',
        ewMeterSpotCom: '',

        hoaApplied: '',
        hoaContactInfo: '',

        unfinishedSurvey: false,

        // Proposal requests variables 
        isOfficeRequestModalOpen: false, // might be able to kill this and use officeRequestModalPage instead
        officeRequestModalPage: '', // options: 'intro', 'selection', final
        officeRequests: [],
        officeRequestProposalType: 'Pricing Only', // Pricing Only / System + Pricing
        officeRequestProposals: [this.createProposalOption()],
        customerInfoChangeTask: {subject: 'Customer Info Change', requestNotes: '', selected: false, extended: true},
        signerChangeTask: {subject: 'Signer/Cosigner Change', requestNotes: '', selected: false, extended: true},
        sendAgreementTask: {subject: 'Send/Re-send Agreement', requestNotes: '', selected: false, extended: true},
        salesRepChangeTask: {subject: 'Sales Rep Addition/Removal', requestNotes: '', selected: false, extended: true},
        otherOfficeRequestTask: {subject: 'Other Office Request', requestNotes: '', selected: false, extended: true},
        inHomeOfficeRequest: false,
        officeRequestLoading: false,
        officeRequestModalError: '',
        isTextOutHold: false,
        textOutHoldReasons: '',
        holdResolvedModalOpen: false,
        holdResolvedButtonsDisabled: false,
        holdResolvedSuccessful: false,
        accountManagementRecord: {},
        assignedAccountManagerName: '',
        assignedAccountManagerEmail: '',
        actionRequired: [], // [{name, isRepActionRequired}]

        // variables needed for the rep action resolved modal.
        repActionResolvedModalOpen: false,
        repNotesToAccountManager: '',
        repActionResolvedButtonDisabled: false,
        isActionPendingReview: false,
        showRepActionResolvedButton: false
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);
        
        // get progress stages, current progress stage, and missing docs:
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpportunity,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const records = res.data.records[0];
                
                if(records.Deal_Documents__c && records.Deal_Documents__r.Text_Out_Hold_Reason__c && records.Deal_Documents__r.Approval_Outcome__c !== 'Approved' && !records.Deal_Documents__r.Deal_Docs_Verified__c){
                    let textOutHoldReasons = records.Deal_Documents__r.Text_Out_Hold_Reason__c.replaceAll(';', ', ');
                    this.setState({isTextOutHold: true, textOutHoldReasons});
                }
                
                // 'missing deal' returns as a string from API -- so must check if we can split it into an array:
                let missingDocs = records.Deal_Documents__r.Missing_Deal_Docs_for_Dashboard__c;
                missingDocs = missingDocs ? missingDocs.split(',') : [];

                const currentProgressStage = records.Internal_Stage__c;

                // set initial post apt. time and post apt. completed time:
                let postAppointmentTime = '';
                let postAppointmentCompleted = '';
                if (records.Post_Appointment_Time__c) {
                    postAppointmentTime = new Date(records.Post_Appointment_Time__c);
                }

                if (records.Post_Appointment_Completed_DT__c) {
                    postAppointmentCompleted = new Date(records.Post_Appointment_Completed_DT__c);
                }

                let rep1SetterCloser = '';
                if(records.Sales_Rep_1_Setter_Closer__c){
                    rep1SetterCloser = records.Sales_Rep_1_Setter_Closer__c;
                }

                let rep2SetterCloser = '';
                if(records.Sales_Rep_2_Setter_Closer__c){
                    rep2SetterCloser = records.Sales_Rep_2_Setter_Closer__c;
                }

                let rep3SetterCloser = '';
                if(records.Sales_Rep_3_Setter_Closer__c){
                    rep3SetterCloser = records.Sales_Rep_3_Setter_Closer__c;
                }

                let cancelSurveyRequest = '';
                if (records.Cancel_Survey_Request__c) {
                    cancelSurveyRequest = new Date(records.Cancel_Survey_Request__c);
                }

                if(records.Contact__c !== null && records.Contact__r.Name != null){
                    this.setState({customerName: records.Contact__r.Name});
                }

                if(records.Contact__c !== null && records.Contact__r.Phone !== null){
                    this.setState({customerPhone: records.Contact__r.Phone});
                }

                if(records.Contact__c !== null && records.Contact__r.Secondary_Phone_for_contact__c !== null){
                    this.setState({customerPhone2: records.Contact__r.Secondary_Phone_for_contact__c});
                }

                if(records.Contact__c !== null && records.Contact__r.Email !== null){
                    this.setState({customerPreferredEmail: records.Contact__r.Email});
                }

                if(records.Contact__c !== null && records.Contact__r.Preferred_Communication__c != null){
                    this.setState({customerPreferredCommunication: records.Contact__r.Preferred_Communication__c});
                }

                if(records.Contact__c !== null && records.Contact__r.Customer_Type__c != null){
                    const customerType = records.Contact__r.Customer_Type__c.split(';');
                    this.setState({customerType: customerType, customerTypeOld: [...customerType]});
                }

                let contractReps = [];
                if(records.Sales_Representative__c !== null){
                    contractReps.push({value: records.Sales_Representative__r.Name, id: records.Sales_Representative__c});
                }

                if(records.Sales_Representative_2__c !== null){
                    contractReps.push({value: records.Sales_Representative_2__r.Name, id: records.Sales_Representative_2__c});
                }

                if(records.Sales_Representative_3__c !== null){
                    contractReps.push({value: records.Sales_Representative_3__r.Name, id: records.Sales_Representative_3__c});
                }

                if(records.Electrical_Work__r.Meter_Spot_Required__c !== null){
                    this.setState({ewMeterSpotRqd: records.Electrical_Work__r.Meter_Spot_Required__c});
                }

                if(records.Electrical_Work__r.Meter_Spot_Submitted__c !== null){
                    this.setState({ewMeterSpotSub: records.Electrical_Work__r.Meter_Spot_Submitted__c});
                }

                if(records.Electrical_Work__r.Meter_Spot_Complete__c !== null){
                    this.setState({ewMeterSpotCom: records.Electrical_Work__r.Meter_Spot_Complete__c});
                }

                if(records.Active_Permit__r?.HOA_Applied__c !== null){
                    this.setState({hoaApplied: records.Active_Permit__r.HOA_Applied__c});
                }

                if(records.Active_Permit__r?.HOA_Contact_Information__c !== null){
                    this.setState({hoaContactInfo: records.Active_Permit__r.HOA_Contact_Information__c});
                }

                if(records.Location__r.Name === 'Dallas'){
                    this.setState({texasLocation: true})
                }

                this.setState({contractReps: contractReps});

                let docMap = new Map();
                docMap.set('credit', records.Deal_Documents__r.Credit_Checked__c);
                docMap.set('usage', records.Deal_Documents__r.Usage__c);
                docMap.set('title', records.Deal_Documents__r.Title_Docs_Trust_Docs_Received__c);
                docMap.set('survey', records.Deal_Documents__r.Scheduled_SS__c);
                docMap.set('agreement', records.Deal_Documents__r.Agreement_Signed__c);
                docMap.set('cpuc', records.Deal_Documents__r.Solar_Info_Packet__c);

                axios.get(
                    '/sf/metaData',
                    {
                        cancelToken: this.source.token
                    })
                    .then((res) => {
                        // convert stages to array of strings:
                        const progressStages = res.data.stages.visible
                            .map(stage => stage.value);

                        const currentStageIndex = progressStages.indexOf(currentProgressStage);

                        this.setState({
                            postAppointmentTime,
                            postAppointmentCompleted,
                            cancelSurveyRequest,
                            progressStages,
                            missingDocs,
                            currentStageIndex,
                            rep1SetterCloser,
                            rep2SetterCloser,
                            rep3SetterCloser,
                            dealDoc: docMap
                        });
                    });

                if(records.StageName === 'Cancel Pending' || records.StageName === 'Cancelled'){
                    this.getLastRetention();   
                }
            })
            .catch(err => console.log('(POST) err from sf/opportunity/findNo: ', err));

        this.getOpportunities();
        this.getAccountManagementData();
        this.getChatter();
        this.getAttempts();
        this.getSurveySessions();

        axios.get('/sf/opportunity/describeField/Company__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const filteredPartners = res.data.picklistValues.filter(item => item.label !== 'Sunlight Financial');
                this.setState({
                    financingPartners: filteredPartners
                });
            });

        axios.get('/sf/opportunity/describeField/Type', {cancelToken: this.source.token})
            .then((res) => {
                this.setState({financingTypes: res.data.picklistValues});
            });

        Promise.all([
            axios.get('/sf/Retention/describeField/Cancellation_Reason__c', { cancelToken: this.source.token }),
            axios.get('/sf/Retention/describeField/Cancellation_Sub_Reason__c', { cancelToken: this.source.token }),
        ]).then(([ctrlRes, depRes]) => {
            const cancelReasons = (ctrlRes.data.picklistValues || []).filter(v => v.active);
            const cancelSubReasons = (depRes.data.picklistValues || []).filter(v => v.active);
            const cancelSubReasonsMap = buildPicklistDependency(cancelReasons, cancelSubReasons);

            this.setState({cancelReasons, cancelSubReasons, cancelSubReasonsMap});
        })

        axios.get('/sf/Contact/describeField/Customer_Type__c', {cancelToken: this.source.token})
            .then((res) => {
                this.setState({customerTypeOptions: res.data.picklistValues});
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    /**
     * @method
     * @methodOf Customer Details
     *
     *
     * @param val {boolean}: value to hide/show the 'survey calendar' view.
     */
     handleShouldShowCalendar = (val) => {
        this.setState({shouldShowCalendar: val, shouldShowInstallCalendar: val});
    };

    // ---------- methods: ----------
    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Handler for when user clicks to save opportunity -- saves opportunity data.
     */
    saveOpportunityOnClick = () => {
        const postAppointmentTime = this.state.postAppointmentTime[0];
        const postAppointmentCompleted = this.state.postAppointmentCompleted[0];
        const cancelSurveyRequest = this.state.cancelSurveyRequest[0];
        const rep1SetterCloser = this.state.rep1SetterCloser;
        const rep2SetterCloser = this.state.rep2SetterCloser;
        const rep3SetterCloser = this.state.rep3SetterCloser;
        let surveyStart = '';

        if(this.state.scheduledSurveys.length !== 0){
            surveyStart = moment(this.state.scheduledSurveys[0].Scheduled_Start__c)._d;
        }

        // the multipicklist shows this.state.customerType values, so we do not need to repull the contact record information after update.
        if(!_.isEqual(this.state.customerType, this.state.customerTypeOld) && this.state.opportunity.Contact__c){
            axios.put(
                '/sf/contact/update',
                {
                    Id: this.state.opportunity.Contact__c,
                    Customer_Type__c: this.state.customerType.join(';')
                },
                {
                    cancelToken: this.source.token
                }
            )
            .then(() => {
                this.setState({customerTypeOld: [...this.state.customerType]});
            })
            .catch(err => console.log('(PUT) Error while trying to update contact: \n', err));
        }

        if(postAppointmentTime < moment()){
            this.setState({patError: true, patErrorMessage: 'Error: Post Appointment Time is in the Past'})
        } else if(surveyStart !== '' && postAppointmentTime < moment(surveyStart).add(24, 'h')) {
            this.setState({patError: true, patErrorMessage: 'Error: Post Appointment Time needs to be scheduled at least 24 hours after survey start time: ' + surveyStart})
        } else {

            if(postAppointmentTime > moment() && postAppointmentTime < moment().add(3,'h')){
                this.setState({patWarning: true});
            }

            const payload = {
                Id: this.customerId,
                Post_Appointment_Time__c: postAppointmentTime,
                Post_Appointment_Completed_DT__c: postAppointmentCompleted,
                Cancel_Survey_Request__c: cancelSurveyRequest,
                Sales_Rep_1_Setter_Closer__c: rep1SetterCloser,
                Sales_Rep_2_Setter_Closer__c: rep2SetterCloser,
                Sales_Rep_3_Setter_Closer__c: rep3SetterCloser,
            };

            axios.put(
                '/sf/opportunity/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    // fetch updated records and close 'edit mode':
                    this.getOpportunities();
                })
                .catch(err => console.log('(PUT) Error while trying to update opportunity: \n', err));
        }
    };

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Handler for when user toggles the form's 'edit' button -- toggles edit mode.
     *
     * @param isEditingCustomer {boolean}: Whether user is editing form or not.
     */
    toggleEditCustomer = (isEditingCustomer) => {
        this.setState({ isEditingCustomer });

        if(isEditingCustomer === false){
            this.setState({patError: false});
        }

        if(isEditingCustomer === false && this.state.opportunity.Post_Appointment_Time__c !== null) {
            this.setState({postAppointmentTime: new Date(this.state.opportunity.Post_Appointment_Time__c)})
        }
    };

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Fetches opportunity data.
     */
    getOpportunities = () => {
        axios.get(
            `/sf/opportunity/findOne/${this.customerId}`,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({opportunity: res.data, oppNotes: res.data.Sales_Notes__c});

                // ensure forms are in 'display mode' rather than 'edit mode':
                this.toggleEditCustomer(false);

                this.getSurveys();
                this.getCases();
                this.getTasks();

                this.getProposals();
                if(!this.state.opportunity.Active_Post_Proposal__c){ // if active post not found - disable install
                    this.setState({disableInstall: true, installErrorNotes: 'Did not find an active Post Proposal for this customer'})
                }
            })
            .catch(err => console.log('(GET) err from sf/opportunity/findOne/:id: ', err));
    };

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Fetches chatter messages/data.
     */
    getChatter = () => {
        axios.post(
            '/sf/chatter/records',
            this.postRequestChatter,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // condition to guard non-existent data:
                if (res.data.results.length && res.data.results[0].result) {
                    let scopedChatter = []; 
                    _.each(res.data.results[0].result.elements, function(c){
                        if(c.body.text){
                            if(c.body.text.includes('@Reps')){
                                scopedChatter.push(c);
                            }
                        }
                    });
                    
                    this.setState({
                        chatter: scopedChatter
                    });
                }
            })
            .catch(err => console.log('(POST) err from sf/chatter/records: ', err));
    };

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Fetches "attempts" data.
     */
    getAttempts = () => {
        axios.post(
            '/sf/attempt/findNo',
            this.postRequestAttempts,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    attempts: res.data.records
                });
            })
            .catch(err => console.log('(POST) Error from sf/attempt/findNo: ', err));
    };

    getSurveySessions = () =>{
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSurveySess,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records;

                if(data.length !== 0 && data.records[0].Scheduled__c){
                    this.setState({unfinishedSurvey: true});
                }
            })
            .catch(err => console.log('(POST) Error finding survey sessions: ', err));
    }

    getLastRetention = () => {
        axios.post(
            '/sf/Retention/findNO',
            this.postRequestRetention,
            {
                cancelToken: this.source.token
            })
            .then(res => {
                const data = res.data.records;
                console.log(data);
                
                if(data && data.length > 0){
                    this.setState({
                        visibleCancelReason: data[0].Cancellation_Reason__c,
                        visibleCancelSubReason: data[0].Cancellation_Sub_Reason__c
                    });
                }
            })
            .catch(err => console.log('(POST) Error finding retention records: ', JSON.stringify(err)));
    }

    getProposals = () => {
        axios.post(
            '/sf/Proposal/findNO', 
            this.postRequestProposals(),
            {
                cancelToken: this.source.token
            })
        .then((res) => {
            const data = res.data.records; // proposals
            let visiblePostProposals = [];

            _.each(data, (prop) => {
                // finding proposals that will be shown under the "Post Proposal" section
                if(prop.Proposal_Stage__c === 'Post' && (prop.Active__c === true || (prop.Proposal_Complete__c !== null && prop.Don_t_Use__c !== true))) {
                    visiblePostProposals.push({
                    ...prop,
                    opened: false,
                    documents: []
                    });
                }

                // active prelim logic
                if(prop.Id === this.state.opportunity.Active_Prelim_Proposal__c){
                    this.setState({prelimProp: prop});

                    if(prop.Contract__c !== null){
                        this.getContract();
                    }
                }

                // active post logic
                if(prop.Id === this.state.opportunity.Active_Post_Proposal__c){
                    if(prop.System_Size__c > 9 || prop.Conduit_run_through_attic__c || prop.Pool_Solar_Removal__c || prop.Powerwashing__c || prop.Number_of_Arrays__c > 4){
                        this.setState({numInstallDays: "2"});
                    }

                    if(prop.Ground_Mount__c || prop.Ground_Mount_Under_9kW__c || prop.Carport__c || prop.Trenching_Concrete_Color_Match__c >= 30 || prop.Trenching_Concrete_No_Color_Match__c >= 30 || prop.Feet_of_Trenching_Dirt__c >= 30 || prop.Reroof__c || prop.Partial_Reroof__c || this.state.opportunity.Jurisdiction_opp__c === 'a1T3l00000ArWTrEAN' || this.state.opportunity.Jurisdiction_opp__c === 'a1T6O000006UnmtUAC' || prop.Full_Reroof__c || (prop.Partial_Reroof_Arrays__c !== null && prop.Partial_Reroof_Arrays__c > 0)){
                        this.setState({disableInstall: true, installErrorNotes: 'Unable to schedule install due to adders'});
                    } else if(!this.state.opportunity.Post_Appointment_Completed_DT__c || this.state.opportunity.Site_Assessment__c === null){
                        this.setState({disableInstall: true, installErrorNotes: 'Unable to schedule install due to missing Post Appointment Completed or Site Assessment'});
                    } else if (prop.RecordTypeId === '0121N000001M82aQAC' || prop.RecordTypeId === '0123l0000012uHOAAY') {
                        this.setState({disableInstall: true, installErrorNotes: 'We are currently unable to schedule installs in Portal for Retrofit customers'});
                    } else if(this.state.opportunity.Jurisdiction_opp__c === 'a1T1N000006iFpRUAU' && this.state.opportunity.Permit_Submitted__c === null) { // Sutter County Jurisdiction Check
                        this.setState({disableInstall: true, installErrorNotes: 'Missing Permit for Sutter County Customer'});
                    } else if(this.state.opportunity.Jurisdiction_opp__c === 'a1T6O000006mEPaUAM' && this.state.opportunity.Permit_Complete__c === null) { // Grand Prairie County Jurisdiction Check
                        this.setState({disableInstall: true, installErrorNotes: 'Missing Permit for Grand Prairie County Customer'});
                    } else {
                        this.setState({disableInstall: false});
                    }
    
                    if(prop.RecordTypeId === '0123l0000012uHJAAY') {
                        this.setState({proposalType: 'Solar Only'})
                    } else if (prop.RecordTypeId === '0123l0000012uHTAAY') {
                        this.setState({proposalType: 'Solar Only'})
                    } else if (prop.RecordTypeId === '0126O000001rO6xQAE') {
                        this.setState({proposalType: 'Solar + ESSD'})
                    }
    
                    let formatPPW = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(prop.Price_per_Watt__c);
                    let formatKWH = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(prop.Price_per_kWh__c);
    
                    this.setState({
                        postProp: prop,
                        prodRatioCheck: prop.Production_Ratio__c,
                        ppw: prop.Price_per_Watt__c,
                        displayedPPW: formatPPW,
                        kwh: prop.Price_per_kWh__c,
                        displayedKWH: formatKWH,
                        monthlyBill: prop.Monthly_Bill_Amount__c,
                        disablePricingButton: false
                    });
                }
            });

            visiblePostProposals.sort((a, b) => {
                if (a.Active__c === b.Active__c) return 0;
                return a.Active__c ? -1 : 1;
            });

            this.setState({visiblePostProposals});

            // running through proposals again after we have set the state.
            _.each(visiblePostProposals, (prop) => {
                this.getProposalCloudDocs(prop.Id);
            })
        })
        .catch(err => console.log('(GET) Error querying Proposals: ', err));
    };

    getProposalCloudDocs = async (propId) => {
        const keys = {};
        fetchS3Photos({
            recordId: propId,
            type: 'a0D-proposal__c',
            existingState: keys,
            source: this.source,
            process: 'getRepUploads'
        })
        .then(returnedFiles => {
            let postProposals = this.state.visiblePostProposals;
            const index = postProposals.findIndex(p => p.Id === propId);
            let prop = postProposals[index];
            Object.keys(returnedFiles).map(doc =>{
                if(returnedFiles[doc] === 'Post Layout' || returnedFiles[doc] === 'Irradiance' || returnedFiles[doc] === 'Battery Placement'){
                    const parts = doc.split('/');
                    const docName = parts[parts.length - 1];
                    prop.documents.push({name: docName, key: 'https://v3-salesforce-file-storage.s3.us-west-2.amazonaws.com/' + doc.Key, type: returnedFiles[doc]});
                }
            })

            postProposals[index] = prop;
            this.setState({visiblePostProposals: postProposals});
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });
    }

    getPostRequestTask = () => {
        axios.post(
            '/sf/task/findNo',
            this.taskRequests,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let tasks = res.data.records;

                if(tasks.length !== 0){
                    let taskDesc = tasks[0].Description;
                    let descArray = taskDesc.split('\n');

                    descArray.forEach(element => {
                        if(element.includes('Financier: ')){
                            this.setState({postFinancier: element.split('Financier: ')[1]});
                        } else if(element.includes('Pricing Method: ')){
                            let methodPrice = element.split('Pricing Method: ')[1];
                            this.setState({postPricingMethod: methodPrice.split(' - ')[0], pricingMethodAmmount: methodPrice.split(' - ')[1]});
                        } else if(element.includes('Production or Offset: ')){
                            this.setState({postOffset: element.split('Production or Offset: ')[1]});
                        } else if(element.includes('Battery Type: ')){
                            this.setState({batteryUse: element.split('Battery Type: ')[1]});
                        } else if(element.includes('Battery Quantity: ')){
                            this.setState({batteryQuant: element.split('Battery Quantity: ')[1]});
                        } else if(element.includes('Escalator: ')){
                            this.setState({postEscalator: element.split('Escalator: ')[1]});
                        } else if(element.includes('Notes: ')){
                            this.setState({postNotes: element.split('Notes: ')[1]});
                        }
                    });

                    this.setState({postRequestTask: tasks[0]});
                }
            })
            .catch(err => console.log('(POST) Error from Retrieving Post Request Tasks: ', err));
    };

    getCases = () => {
        axios.post('/sf/Case/findNo', this.postRequestCase, {cancelToken: this.source.token})
            .then((res) => {
                let cases = res.data.records;
                const visibleOfficeRequests = [];
                
                cases.forEach(c => {
                    if(c.Type == 'Office Request'){
                        let disregardDisabled = false;
                        const createdDate = moment(c.CreatedDate).format('YYYY-MM-DD');

                        // Fields that will be visible for the rep
                        let fields = [];
                        fields.push({name: 'Customer Signature', value: c.Customer_Signature__c});
                        fields.push({name: 'Following Up on Signature', value: c.Following_Up_on_Signature__c});
                        fields.push({name: 'Reason for New Signature', value: c.Reason_for_New_Signature__c});
                        fields.push({name: 'Signature Received Date', value: (c.Signature_Received__c ?  moment(c.Signature_Received__c).format('MM/D/YY h:mmA') : '')});
                        fields.push({name: 'Post OA', value: c.Post_OA__r?.Name});
                        fields.push({name: 'Post ETA', value: (c.Post_ETA__c ? moment(c.Post_ETA__c).format('MM/D/YY h:mmA') : '')});
                        fields.push({name: 'Proposal Completed Date', value: (c.Post_Completed_Date__c ? moment(c.Post_Completed_Date__c).format('MM/D/YY h:mmA') : '')});

                        let status = 'Open';
                        let statusColor = 'text-info'; // blue
                        if(c.Post_Completed_Date__c){
                            status = 'Completed';
                            statusColor = 'text-success'; // green
                            disregardDisabled = true;
                        } else if(c.IsClosed == true || c.Office_Request_Disregarded_By_Rep__c){
                            status = 'Disregarded';
                            statusColor = 'text-danger'; // red
                            disregardDisabled = true;
                        } else if(c.Post_OA__c){
                            status = 'In Progress'
                            statusColor = 'text-warning' // yellow
                        }
                        
                        let caseOfficeReq = {};
                        caseOfficeReq.id = c.Id;
                        caseOfficeReq.extended = false;
                        caseOfficeReq.name = (c.Subject.includes(' – ') ? c.Subject.split(' – ')[1] : c.Subject) + ' - ' + createdDate;
                        caseOfficeReq.fields = fields;
                        caseOfficeReq.status = status;
                        caseOfficeReq.statusColor = statusColor;
                        caseOfficeReq.createdDate = createdDate;
                        caseOfficeReq.disregardDisabled = disregardDisabled;
                        caseOfficeReq.record = c;
                        caseOfficeReq.requestNotes = this.buildOptionInfo(c);

                        visibleOfficeRequests.push(caseOfficeReq);
                    }

                    if(visibleOfficeRequests && visibleOfficeRequests.length > 0){
                        // this logic is needed to update the state correctly since 2 methods access it.
                        this.setState(prev => {
                            const mapById = {};

                            // adding all the existing to the map.
                            prev.visibleOfficeRequests.forEach(r => {
                                mapById[r.id] = r;
                            });

                            // overriding the existing ones by the SOQLed and adding new ones
                            visibleOfficeRequests.forEach(r => {
                                mapById[r.id] = r;
                            });

                            // sorted by created date
                            const sorted = Object.values(mapById).sort((a, b) => new Date(b.record.CreatedDate) - new Date(a.record.CreatedDate));

                            return { visibleOfficeRequests: sorted };
                        });
                    }
                });
            })
        .catch(err => console.log('(POST) Error finding cases: ', err));
    }

    getTasks = () => {
        axios.post('/sf/Task/findNo', this.postRequestTask, {cancelToken: this.source.token})
            .then((res) => {
                let tasks = res.data.records;
                const visibleOfficeRequests = [];

                tasks.forEach(t => {
                    if(t.Type == 'Office Request'){
                        let disregardDisabled = false;
                        const createdDate = moment(t.CreatedDate).format('YYYY-MM-DD');

                        // Fields that will be visible for the rep
                        let fields = [];
                        fields.push({name: 'Assigned To', value: t.Owner.Name});
                        fields.push({name: 'Completion Date', value: (t.Completion_Date__c ? moment(t.Completion_Date__c).format('YYYY-MM-DD') : '')});
                        fields.push({name: 'Conclusion', value: t.Conclusion__c});

                        let status = 'Open';
                        let statusColor = 'text-info'; // blue
                        if(t.Completion_Date__c && t.Conclusion__c === 'Disregarded'){
                            status = 'Disregarded';
                            statusColor = 'text-danger'; // red
                            disregardDisabled = true;
                        } else if(t.Completion_Date__c){
                            status = 'Completed';
                            statusColor = 'text-success'; // green
                            disregardDisabled = true;

                        // by default the task will be assigned to the proposal or AM group. If the type of the owner is a user, it means the task is in progress
                        } else if(t.Owner.Type == 'User'){
                            status = 'In Progress'
                            statusColor = 'text-warning' // yellow
                        }

                        let taskOfficeReq = {};
                        taskOfficeReq.id = t.Id;
                        taskOfficeReq.extended = false;
                        taskOfficeReq.name = t.Subject + ' - ' + createdDate;
                        taskOfficeReq.fields = fields;
                        taskOfficeReq.status = status;
                        taskOfficeReq.statusColor = statusColor;
                        taskOfficeReq.disregardDisabled = disregardDisabled;
                        taskOfficeReq.requestNotes = t.Description;
                        taskOfficeReq.record = t;

                        visibleOfficeRequests.push(taskOfficeReq);
                    }
                })

                if(visibleOfficeRequests && visibleOfficeRequests.length > 0){
                    // this logic is needed to update the state correctly since 2 methods access it.
                    this.setState(prev => {
                        const mapById = {};

                        // adding all the existing to the map.
                        prev.visibleOfficeRequests.forEach(r => {
                            mapById[r.id] = r;
                        });

                        // overriding the existing ones by the SOQLed and adding new ones
                        visibleOfficeRequests.forEach(r => {
                            mapById[r.id] = r;
                        });
                        // sorted by created date
                        const sorted = Object.values(mapById).sort((a, b) => new Date(b.record.CreatedDate) - new Date(a.record.CreatedDate));

                        return { visibleOfficeRequests: sorted };
                    });
                }
            })
            .catch(err => console.log('(POST) Error finding tasks: ', err));
    }

    getContract = () => {
        if(this.state.prelimProp.Contract__c !== null){
            axios.get(
                `/sf/contract/findOne/${this.state.prelimProp.Contract__c}`,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    const data = res.data;
                    this.setState({contract: data});
                })
                .catch(err => console.log('(GET) Error tyring to fetch contract record: ', err));
        }

        axios.get(
            `/sf/contact/findOne/${this.state.opportunity.Contact__c}`,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                this.setState({primaryOppContact: data});
            })
            .catch(err => console.log('(GET) Error tyring to fetch primary contact record: ', err));

        let repContactQuery = '/sf/contact/findOne/';

        if(this.state.opportunity.Sales_Rep_1_Setter_Closer__c === 'Closer') {
            repContactQuery = repContactQuery + this.state.opportunity.Sales_Representative__c;
        } else if(this.state.opportunity.Sales_Rep_2_Setter_Closer__c === 'Closer') {
            repContactQuery = repContactQuery + this.state.opportunity.Sales_Representative_2__c;
        } else if(this.state.opportunity.Sales_Rep_3_Setter_Closer__c === 'Closer') {
            repContactQuery = repContactQuery + this.state.opportunity.Sales_Representative_3__c;
        } else {
            repContactQuery = repContactQuery + this.state.opportunity.Sales_Representative__c;
        }

        axios.get(
            repContactQuery,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                this.setState({salesRepContact: data});
            })
            .catch(err => console.log('(GET) Error tyring to fetch sales rep contact record: ', err));
    };

    getAccountManagementData = () => {
        axios.post('/sf/AccountManagement/findNo', this.postRequestAccountManagement, {cancelToken: this.source.token})
            .then((res) => {
                const repBasedActionRequired = ['Pending Rep Approval', 'Documents Required', 'Out of Pocket Required', 'Change Order Required', 'New Agreement Required', 'EPC Change Required', 'Customer Correspondence Required'];
                let accountManagement = res.data.records[0];
                let actionRequired = [];
                let isActionPendingReview = false;
                
                if(!accountManagement){
                    return;
                }

                if(accountManagement.Action_Required__c){
                    accountManagement.Action_Required__c.split(';').forEach(action => {
                        actionRequired.push({name: action, isRepActionRequired: repBasedActionRequired.includes(action)});
                    });
                }

                isActionPendingReview = accountManagement.Rep_Action_Requested__c && accountManagement.Rep_Action_Resolved__c;

                this.setState({
                    accountManagementRecord: accountManagement,
                    assignedAccountManagerName: accountManagement.Assigned_Account_Manager__r?.Name,
                    assignedAccountManagerEmail: accountManagement.Assigned_Account_Manager__r?.Sales_Rep_Account__r?.Email__c,
                    nextStep: accountManagement.Next_Step__c,
                    actionRequired: actionRequired,
                    isActionPendingReview: isActionPendingReview,
                    showRepActionResolvedButton: accountManagement.Rep_Action_Requested__c
                });
            })
            .catch(err => console.log('(POST) Error finding account management data: ', err));
    }

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Handler for when user clicks "save attempt" button (found in the modal) -- attempts to save data (POST request).
     */
    modalLogAttemptOnClick = () => {
        const payload = {
            Name: "Opportunity Attempt",
            Sales_Rep__c: this.props.user.apiId,
            Type__c: this.state.logAttemptType,
            Opportunity_Name__c: this.customerId,
            Notes__c: this.state.logAttemptNotes,
            Call_Outcome__c: this.state.logAttemptType === 'Call' ? this.state.logAttemptOutcome : ''
        };

        axios.post(
            '/sf/attempt/create',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // fetch updated attempts:
                this.getAttempts();

                // clear modal form and close modal:
                this.setState({
                    isModelOpen: false,
                    logAttemptType: '',
                    logAttemptNotes: '',
                    logAttemptOutcome: ''
                });
            })
            .catch(err => console.log('(POST) Error while trying to add new log attempt:\n', err));
    };

    submitOfficeRequestOnClick = () => {
        this.setState({officeRequestLoading : true});

        let req = {
            TypeOfLead: 'OfficeRequest', 
            Id: this.customerId
        };

        if(this.state.officeRequests.includes('Proposal Request')){
            let ProposalRequest = {
                selectedProposalType: this.state.officeRequestProposalType,
                proposalRequestNotes: '',
                inHome: this.state.inHomeOfficeRequest,
                option1: {},
                option2: {},
                option3: {}
            };

            if(this.state.officeRequestProposals[0]){
                let prop = {...this.state.officeRequestProposals[0]};
                prop.rate = prop.rate ? parseFloat(prop.rate)/100 : prop.rate;

                ProposalRequest.proposalRequestNotes += 'Proposal 1: '+ prop.notes;
                ProposalRequest.option1 = prop;
            }

            if(this.state.officeRequestProposals[1]){
                let prop = {...this.state.officeRequestProposals[1]};
                prop.rate = prop.rate ? parseFloat(prop.rate)/100 : prop.rate;

                ProposalRequest.proposalRequestNotes += ', Proposal 2: '+ prop.notes;
                ProposalRequest.option2 = prop;
            }

            if(this.state.officeRequestProposals[2]){
                let prop = {...this.state.officeRequestProposals[2]};
                prop.rate = prop.rate ? parseFloat(prop.rate)/100 : prop.rate;

                ProposalRequest.proposalRequestNotes += ', Proposal 3: '+ prop.notes;
                ProposalRequest.option3 = prop;
            }

            req.ProposalRequest = ProposalRequest;
        }

        let tasks = [];
        if(this.state.customerInfoChangeTask && this.state.officeRequests.includes(this.state.customerInfoChangeTask.subject)){
            tasks.push(this.state.customerInfoChangeTask);
        }
        if(this.state.signerChangeTask && this.state.officeRequests.includes(this.state.signerChangeTask.subject)){
            tasks.push(this.state.signerChangeTask);
        }
        if(this.state.sendAgreementTask && this.state.officeRequests.includes(this.state.sendAgreementTask.subject)){
            tasks.push(this.state.sendAgreementTask);
        }
        if(this.state.salesRepChangeTask && this.state.officeRequests.includes(this.state.salesRepChangeTask.subject)){
            tasks.push(this.state.salesRepChangeTask);
        }
        if(this.state.otherOfficeRequestTask && this.state.officeRequests.includes(this.state.otherOfficeRequestTask.subject)){
            tasks.push(this.state.otherOfficeRequestTask);
        }

        if(tasks.length > 0){
            req.TaskRequest = {tasks: tasks};
        }

        axios.post('/leadPost', req, {cancelToken: this.source.token})
        .then((res) => {
            this.setState({officeRequestLoading : false});

            if(typeof res.data === 'object' || (typeof res.data === 'string' && res.data.includes('Error'))){
                this.setState({officeRequestModalError: res.data});
            } else {
                this.getCases();
                this.getTasks();
                this.closeOfficeRequestModal();
            }
        })
        .catch(err => {
            console.log('Error Creating Office Request Records :\n', JSON.stringify(err))
            this.setState({officeRequestLoading : false});
        })
    };

    openOfficeRequestModal() {
        this.setState({isOfficeRequestModalOpen: true});

        // if install has been scheduled or has been completed -> show "Call Your Account Manager" page
        if(this.state.opportunity.Install_Scheduled_Start__c || this.state.opportunity.Install_Complete__c || this.state.opportunity.Battery_Install_Scheduled_Start__c || 
                this.state.opportunity.Battery_Install_Complete__c || this.state.opportunity.Roof_Install_Completed__c){
            this.setState({officeRequestModalPage: 'locked'});
        } else {
            this.setState({officeRequestModalPage: 'intro'});
        }
    }

    closeOfficeRequestModal() {
        this.setState({
            isOfficeRequestModalOpen: false,
            officeRequestModalPage: '',
            officeRequests: [],
            officeRequestProposalType: 'Pricing Only',
            officeRequestProposals: [this.createProposalOption()],
            customerInfoChangeTask: {subject: 'Customer Info Change', requestNotes: '', selected: false, extended: true},
            signerChangeTask: {subject: 'Signer/Cosigner Change', requestNotes: '', selected: false, extended: true},
            sendAgreementTask: {subject: 'Send/Re-send Agreement', requestNotes: '', selected: false, extended: true},
            salesRepChangeTask: {subject: 'Sales Rep Addition/Removal', requestNotes: '', selected: false, extended: true},
            otherOfficeRequestTask: {subject: 'Other Office Request', requestNotes: '', selected: false, extended: true},
            inHomeOfficeRequest: false,
            officeRequestLoading: false,
            officeRequestModalError: ''
        });
    }

    submitOfficeReqDisabled() {
        if(this.state.officeRequestLoading){
            return true;
        }

        const needsProposal = this.state.officeRequests.includes('Proposal Request');
        const hasInvalidProposal = needsProposal && this.state.officeRequestProposals.some((_, idx) => !this.validateSingleProposal(idx));
        if(hasInvalidProposal){
            return true;
        }

        const tasks = [this.state.customerInfoChangeTask, this.state.signerChangeTask, this.state.sendAgreementTask, this.state.salesRepChangeTask, this.state.otherOfficeRequestTask];
        const hasInvalidTask = tasks.some(task => 
            this.state.officeRequests.includes(task.subject) && (!task.requestNotes || !task.requestNotes.trim())
        );
        if(hasInvalidTask) {
            return true;
        }

        return false;
    }

    // generate a default proposal option
    createProposalOption() {
        // picklists are required to be '' for correct rendering
        return {
            financier: '', financingType: '', epc: null, monthly: null, offset: null,
            production: null, rate: null, escalator: null, layoutNotes: null,
            batteryType: '', batteryQuantity: null, notes: null, priorities: [], extended: true
        };
    }

    validateSingleProposal = idx => {
        const p = this.state.officeRequestProposals[idx];
        // fields that count toward “has info” (exclude notes & priorities)
        const requiredFields = ['financier','financingType','epc','monthly','offset','production','rate','escalator','layoutNotes','batteryType','batteryQuantity'];

        return requiredFields.some(f => {
            const v = p[f];
            return v !== null && v !== undefined && String(v).trim() !== '' && v !== '';
        });
    };

    // append new one if under limit
    addProposal = () => {
        this.setState(({ officeRequestProposals }) => {
        if (officeRequestProposals.length >= 3) return null;
        return {
            officeRequestProposals: [
            ...officeRequestProposals,
            this.createProposalOption()
            ]
        };
        });
    };

    removeProposal = (idx) => {
        this.setState(({ officeRequestProposals }) => {
        const newArr = officeRequestProposals.slice();
        newArr.splice(idx, 1);
        return { officeRequestProposals: newArr };
        });
    };

    // updates any field on a proposal
    updateProposalField = (idx, field, value) => {
        this.setState(({ officeRequestProposals }) => ({
            officeRequestProposals: officeRequestProposals.map((p, i) =>
            i === idx ? { ...p, [field]: value } : p
            )
        }));
    };

    toggleProposalExtended = (idx) => {
        this.setState(({ officeRequestProposals }) => ({
            officeRequestProposals: officeRequestProposals.map((p, i) =>
            i === idx ? { ...p, extended: !p.extended } : p
            )
        }));
    };

    disregardOfficeRequest = (req) => {
        if(req.id && req.id.startsWith('500')){ // case
            const payload = {
                Id: req.id,
                Status: 'Closed',
                Office_Request_Disregarded_By_Rep__c: moment().format(this.SF_DATE_TIME_FORMAT),
                Description: 'Office request disregarded at rep request. \n\n' + (req.record?.Description ? req.record.Description : ''),
            };

            axios.put('/sf/case/update', payload, { cancelToken: this.source.token })
                .then((res) => {
                    this.getCases();
                })
                .catch(err => console.log('(PUT) Error while trying to disregard case office request : \n', err));

        } else if (req.id && req.id.startsWith('00T')){ // task
            const payload = {
                Id: req.id,
                Status: 'Completed',
                Description: 'Office request disregarded at rep request. \n\n' + (req.record?.Description ? req.record.Description : ''),
                Conclusion__c: 'Disregarded'
            };

            axios.put('/sf/task/update', payload, { cancelToken: this.source.token })
                .then((res) => {
                    this.getTasks();
                })
                .catch(err => console.log('(PUT) Error while trying to disregard task office request : \n', err));
        }
    }

    buildOptionInfo(c) {
        const fields = [
            { key: 'Financier__c',       label: 'Financier' },
            { key: 'Financing_Type__c',  label: 'Financing Type' },
            { key: 'EPC__c',             label: 'EPC' },
            { key: 'Monthly__c',         label: 'Monthly' },
            { key: 'Offset__c',          label: 'Offset' },
            { key: 'Production__c',      label: 'Production' },
            { key: 'Rate__c',            label: 'Rate' },
            { key: 'Escalator__c',       label: 'Escalator' },
            { key: 'Layout__c',          label: 'Layout Notes' },
            { key: 'Battery_Type__c',    label: 'Battery Type' },
            { key: 'Battery_Quantity__c',label: 'Battery Quantity' },
            { key: 'Priorities__c',      label: 'Priorities' }
        ];

        let info = '';

        for (let i = 1; i <= 3; i++) {
            const prefix = `Option_${i}_`;
            const lines = fields
            .map(f => {
                const val = c[prefix + f.key];
                return (val !== null && val !== undefined && val !== '')
                ? `${f.label}: ${val}`
                : null;
            })
            .filter(line => line);

            // only if there's at least one filled field
            if (lines.length) {
            // add header + fields + one blank line
            info += `Option ${i}:\n` +
                    lines.join('\n') +
                    '\n\n';
            }
        }

        return info.trim();  // removes trailing newline
    }

    officeReqPricingOnly = () => {
        this.setState(prev => ({
        officeRequestProposalType: 'Pricing Only',
        officeRequestProposals: prev.officeRequestProposals.map(p => ({
            ...p,
            // clear the System + Pricing fields:
            financier: '',
            offset: null,
            production: null,
            layoutNotes: '',
            batteryType: '',
            batteryQuantity: null
        }))
        }));
    }

    requestRevisionOnClick = () => {
        this.setState({disableRevButton: true})
        let descriptionString = 'Offset: ' + this.state.revOffset + '\nRate: ' + this.state.revRate + '\nEPC: ' + this.state.revEPC + '\nMonthly: ' + 
            this.state.revMonthly + '\nLayout: ' + this.state.revLayout + '\nPriority List: ' + this.state.revPriority + '\nNotes: ' + this.state.revNotes;
        let subString = 'Revision from Rep';
        let requestedRevision = 'Rep';
        let requestDate = moment().format('yyyy-MM-DDTHH:mm:ss.SSS');

        const payload = {
            Opportunity__c: this.state.opportunity.Id,
            Description: descriptionString,
            Post_Requested_Date__c: requestDate,
            Subject: subString,
            Requested_Revision__c: requestedRevision,
            OwnerId: '0051N000004v90w',
            RecordTypeId: '0121N000001I0k8'
        };

        axios.post(
            '/sf/case/create',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // Return to customer page after save
                this.setState({
                    isPropRevModalOpen: false,
                    disableRevButton: false
                });
            })
            .catch(err => {
                console.log('(POST) Error while trying to create revision case:\n', err);
                this.setState({
                    revCreateFail: true,
                    disableRevButton: false
                });
            });
    };

    splitString = (string) => {
        let arrayString = string.split('\n');

        return arrayString;
    };

    // Create or Update Post Prop Contact by Calling RunContract Method in Salesforce
    createContract = () => {
        this.setState({creatingContract: true});
        let payload = {
            PrelimId: this.state.postProp.Id,
            RepId: this.state.repIdForContract,
            TypeOfLead: 'Contract'
        };

        console.log(payload);

        axios.post(
            '/leadPost',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                let contractRes = res.data;
                
                setTimeout(() => {
                    this.setState({createdContract: 'green'});
                    this.getNewContract(contractRes);
                }, 3000);
            })
            .catch(err => {
                this.setState({createdContract: 'red'});
                console.log('PUT Error creating contract:\n', err)
            });
    };

    // Retrieve Created or Updated Contract from Salesforce
    getNewContract = (cId) => {
        let contractUrl = '/sf/contractNew/findOne/' + cId;
        
        axios.get(
            contractUrl,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                this.setState({newContract: data});
            })
            .catch(err => {
                this.setState({createdDoc: 'red'});
                console.log('(GET) Error tyring to fetch contract records: ', err);
            });
    };

    // Method to create the PandaDoc Agreement
    createPandaDocAgreement = () => {
        this.setState({agreementConfirm: true, creatingContract: false});
        
        let payload = {
            TypeOfLead: 'SendContract',
            ContractId: this.state.newContract.Id,
            Confirm: true
        }

        axios.post(
            '/leadPost',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                let status = res.data;

                if(status === 'Processed Request'){
                    this.setState({createdDoc: 'green'})

                    setTimeout(() => {
                        this.getContractStatus();
                    }, 7000);
                } else {
                    this.setState({createdDoc: 'red'})
                }
            })
            .catch(err => {
                this.setState({createdDoc: 'red'})
                console.log('Error invoking SendContract:\n', err)
            })
    };

    // Retrieve Created or Updated Contract from Salesforce
    getContractStatus = () => {
        this.setState({docStatus: 'green'});

        setTimeout(() => {
            axios.get(
                '/sf/contractNew/findOne/' + this.state.newContract.Id,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    const data = res.data;

                    if(data.Status__c === 'Sent'){
                        this.setState({sentDoc: 'green'});
                    } else {
                        this.setState({sentDoc: 'red'});
                    }
                })
                .catch(err => {
                    this.setState({sentDoc: 'red'});
                    console.log('(GET) Error tyring to fetch contract records: ', err);
                });
        }, 5000);
    };

    getSurveys = () => {
        axios.post(
            '/sf/workOrder/findNO',
            this.postSchedSurvey,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let surveys = res.data.records;

                if(surveys.length !== 0){
                    this.setState({scheduledSurveys: surveys, showCancelSurvey: false});
                } else {
                    this.setState({showCancelSurvey: true});
                }
            })
            .catch(err => {
                console.log('(POST) Error while trying to query surveys:\n', err);
            });
    };

    cancelSurvey = (surveyId) => {
        this.setState({disableCancelSurvey: true})

        const payload = {
            Id: surveyId,
            Cancel_Date_Time__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
            Office_Cancellation_Notes__c: 'Sales Rep-generic cancellation',
        };

        axios.put(
            '/sf/workOrder/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.getOpportunities();
                this.setState({disableCancelSurvey: false, cancelSurveyModal: false})
            })
            .catch(err => {
                console.log('(PUT) Error while trying to cancel survey: \n', err)
                this.setState({errorCancelSurvey: true})
            });
    };

    toggleOfficeRequest = requestName => {
        this.setState(prev => {
        const { officeRequests } = prev;
        if (officeRequests.includes(requestName)) {
            return { officeRequests: officeRequests.filter(r => r !== requestName) };
        } else {
            return { officeRequests: [...officeRequests, requestName] };
        }
        });
    };

    acceptRetention = () => {
        this.setState({retentionModal: true});

        let payload = {
            TypeOfLead: 'Retention',
            Id: this.state.opportunity.Id
        }

        axios.post(
            '/leadPost',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                let status = res.data;
                this.setState({retentionNotes: status});
            })
            .catch(err => {
                console.log('Error Accepting Retention:\n', err)
            })
    }

    saveOppNotes = () => {
        console.log(this.state.oppNotes);
        this.setState({oppNotesDisabled: true});

        const payload = {
            Id: this.customerId,
            Sales_Notes__c: this.state.oppNotes
        };

        axios.put(
            '/sf/opportunity/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                console.log(res.data);
                this.setState({oppNotesDisabled: false, oppNoteSaveSuccess: true});
                setTimeout(() => this.setState({oppNoteSaveSuccess: false}), 5000);
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update lead: \n', err);
                this.setState({oppNotesDisabled: false});
            });
    };

    toggleProposal = (proposalId) => {
        this.setState(prevState => ({
            visiblePostProposals: prevState.visiblePostProposals.map(proposal =>
                proposal.Id === proposalId ? { ...proposal, opened: !proposal.opened } : proposal
            )
        }));
    };

    toggleVisibleOfficeRequest = (reqId) => {
        this.setState(prev => ({
            visibleOfficeRequests: prev.visibleOfficeRequests.map(req =>
            req.id === reqId ? { ...req, extended: !req.extended } : req
          )
        }));
    };

    createRetentionRecord = () => {
        this.setState({disableCancelPending: true});
        const cancelReason = this.state.reason;
        const cancelSubReason = this.state.subReason;

        const payload = {
            Cancel_Pending_Date__c: moment().format('YYYY-MM-DD'),
            Cancellation_Reason__c: cancelReason,
            Cancellation_Sub_Reason__c: cancelSubReason,
            Cancellation_Reason_Specific__c: this.state.reasonSpecific,
            Opportunity__c: this.state.opportunity.Id,
            Notes__c: 'This retention record was created by ' + this.props.user.name + ' from Portal.'
        };

        axios.post(
            '/sf/Retention/create',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    isCancelPendingModalOpen: false,
                    disableCancelPending: false,
                    reason: '',
                    subReason: '',
                    reasonSpecific: '',

                    // these fields are pulled only on initial load of the page, so we are setting them manually if a new retention is created
                    visibleCancelReason: cancelReason,
                    visibleCancelSubReason: cancelSubReason,
                });

                this.getOpportunities();
            })
            .catch(err => console.log('(POST) Error while trying to create retention record:\n', err)); 
    };

    confirmHoldResolved = () => {
        this.setState({holdResolvedButtonsDisabled: true})

        const payload = {
            Id: this.state.opportunity.Deal_Documents__c,
            Text_out_hold_Recheck__c: moment().format(this.SF_DATE_TIME_FORMAT) // now
        };

        axios.put(
            '/sf/DealDocument/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({holdResolvedButtonsDisabled: false, holdResolvedSuccessful: true});
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update deal docs: \n', err);
                this.setState({holdResolvedButtonsDisabled: false});
            });
    }

    closeHoldResolved = () => {
        this.setState({
            holdResolvedModalOpen: false,
            holdResolvedSuccessful: false,
            holdResolvedButtonsDisabled: false
        })
    }

    closeRepActionResolved = () => {
        this.setState({
            repActionResolvedModalOpen: false,
            repNotesToAccountManager: '',
            repActionResolvedButtonDisabled: false
        })
    }

    resolveRepAction = () => {
        this.setState({repActionResolvedButtonDisabled: true});
        
        const payload = {
            Id: this.state.accountManagementRecord.Id,
            Rep_Action_Resolved__c: moment().format(this.SF_DATE_FORMAT),
            Notes_from_Rep__c: this.state.repNotesToAccountManager
        }

        axios.put(
            '/sf/AccountManagement/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.getAccountManagementData();
                this.closeRepActionResolved();
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update account management record: \n', err);
                this.setState({repActionResolvedButtonDisabled: false});
            });
    }

    render() {
        const viewCustomer = <>
            <div className={css.CustomerDetails}>
                {/* ---------- header info: ---------- */}
                <div className="row">
                    {/* ----- row 1: ----- */}
                    <div className="col-12 col-md-6 mb-2">
                        <h4>name</h4>
                        <h1>{this.state.opportunity.Name}</h1>
                    </div>
                    <div className="col-12 col-md-6 mb-2">
                        <h4>size</h4>
                        <h1>{this.state.opportunity.Current_System_Size__c}</h1>
                    </div>

                    {/* ----- row 2: ----- */}
                    {/* shift deal closed and sold deal to the left if text out hold reasons are visible. */}
                    <div className={this.state.isTextOutHold ? "col-12 col-md-3 mb-2" : "col-12 col-md-6 mb-2"}>
                        <h4>deal closed</h4>
                        <h1>{formatShortDate(this.state.opportunity.CloseDate)}</h1>
                    </div>
                    <div className={this.state.isTextOutHold ? "col-12 col-md-3 mb-2" : "col-12 col-md-6 mb-2"}>
                        <h4>sold date</h4>
                        <h1>{formatShortDate(this.state.opportunity.Sold_Deal_Date__c)}</h1>
                    </div>
                    <div className={this.state.isTextOutHold ? "col-12 col-md-6 mb-2" : "d-none"}>
                        <h4>Text Out Hold Reasons</h4>
                        <h1 className="text-danger">{this.state.textOutHoldReasons || '---'}</h1>
                    </div>

                    {/* ----- row 3: ----- */}
                    <div className="col-12 col-md-3 mb-2">
                        <h4>stage</h4>
                        <h1>{replaceInternalStage(this.state.opportunity.Internal_Stage__c)}</h1>
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                        <h4>milestone</h4>
                        <h1>{replaceStageName(this.state.opportunity)}</h1>
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                        <h4>status</h4>
                        <h1>{this.state.opportunity.Status__c === 'Sold Deal' ? 'Pre-Sold Deal' : this.state.opportunity.Status__c}</h1>
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                        <h4>Sub Status</h4>
                        <h1>{this.state.opportunity.Sub_Status_new__c ? this.state.opportunity.Sub_Status_new__c : '---'}</h1>
                    </div>

                    {/* ----- row 4: ----- */}
                    <div className={this.state.opportunity.StageName === 'Cancel Pending' || this.state.opportunity.StageName === 'Cancelled' ? "col-12 col-md-6 mb-2" : "d-none"}>
                        <h4>Cancellation Reason</h4>
                        <h1>{this.state.visibleCancelReason ? this.state.visibleCancelReason : '---'}</h1>
                    </div>
                    <div className={this.state.opportunity.StageName === 'Cancel Pending' || this.state.opportunity.StageName === 'Cancelled' ? "col-12 col-md-6 mb-2" : "d-none"}>
                        <h4>Cancellation Sub-Reason</h4>
                        <h1>{this.state.visibleCancelSubReason ? this.state.visibleCancelSubReason : '---'}</h1>
                    </div>

                    {/* Might be better to be above status row */}
                    {/* ----- row 5: ----- */}
                    <div className="col-12 col-md-6 mb-2">
                        <h4>Assigned Account Manager</h4>
                        <h1 className="mb-0">
                            {this.state.assignedAccountManagerName ? this.state.assignedAccountManagerName : "---"}
                        </h1>

                        {this.state.assignedAccountManagerName && this.state.assignedAccountManagerEmail ? (
                            <div className="text-light small mb-1">
                                {this.state.assignedAccountManagerEmail}
                            </div>
                        ) : null}
                    </div>
                    <div className={this.state.actionRequired && this.state.actionRequired.length > 0 ? "col-12 col-md-6 mb-2" : "d-none"}>
                        <h4>Action Required</h4>
                        <h1 className="mb-0">
                            {this.state.actionRequired.map(action => 
                                <div key={action.name} className={action.isRepActionRequired ? 'text-danger' : ''}>
                                    {action.name}
                                </div>
                            )}
                        </h1>
                        <div className={this.state.isActionPendingReview ? "text-light small" : "d-none"}>
                                (Pending Review)
                        </div>
                    </div>
                </div>

                {/* progress steps:: */}
                <Progress currentStageIndex={this.state.currentStageIndex} stages={this.state.progressStages.map(stage => replaceInternalStage(stage))}  />

                {/* ---------- main section: ---------- */}
                <div className={`${css.CustomerDetails__Main} mt-3`}>

                    {/* ----- CTA Buttons: ---- */}
                    <div className="text-center d-flex flex-column d-sm-block">
                        {
                            this.state.patError ? 
                            <div className='text-center text-danger text-uppercase pb-2'>{this.state.patErrorMessage}</div>
                            :
                            ''
                        }
                        {
                            this.state.patWarning ? 
                            <div className='text-center text-warningC text-uppercase pb-2'>Warning: Post Appointment Time is within 3 hours and Proposals may not be able to meet deadline</div>
                            :
                            ''
                        }
                        {
                            this.state.isEditingCustomer ?
                                (
                                    <>
                                        <button className="btn btn-primary" type="button" onClick={() => this.toggleEditCustomer(false)}>cancel</button>
                                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" type="button" onClick={() => this.saveOpportunityOnClick()}>save</button>
                                    </>
                                )
                                :
                                ( <button className="btn btn-primary" type="button" onClick={() => this.toggleEditCustomer(true)}>edit customers</button> )
                        }

                        <button className={this.state.isTextOutHold ? "btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" : "d-none"} onClick={() => this.setState({holdResolvedModalOpen: true})}>Text Out Hold Recheck</button>
                        <Link to={`/attachment/${this.customerId}/${this.state.opportunity.Name}`}>
                            <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto"><FontAwesomeIcon icon={faPlus} /> attachments</button>
                        </Link>
                        {/* <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.setState({isPostModalOpen: true})}>Request Post</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.setState({isPropRevModalOpen: true})}>Proposal Revision</button> */}
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" disabled={!this.state.opportunity.Id} onClick={() => {this.openOfficeRequestModal()}}>Office Request</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={this.state.unfinishedSurvey ? () => this.setState({showUnfinishedSurvey: true}) : () => this.setState({shouldShowCalendar: true})}>Schedule Survey</button>
 
                        <div className="d-none d-sm-block"><br/></div>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" disabled={this.state.showCancelSurvey} onClick={() => this.setState({cancelSurveyModal: true})}>Cancel Survey</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={this.state.disableInstall ? () => this.setState({installErrorModal: true}) : () => this.setState({shouldShowInstallCalendar: true})}>Schedule Install</button>
                        <button className={this.state.opportunity.Id && this.state.opportunity.StageName !== 'Cancel Pending' && this.state.opportunity.StageName !== 'Cancelled' ? "btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" : "d-none"}  onClick={() => this.setState({isCancelPendingModalOpen: true})}>Cancel Pending</button>
                        <button className={this.state.opportunity.StageName === 'Cancel Pending' ? "btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" : "d-none"} onClick={() => this.acceptRetention()}>Accept Save</button>
                        <button className={this.state.showRepActionResolvedButton ? "btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" : "d-none"} onClick={() => this.setState({repActionResolvedModalOpen: true})}>Rep Action Resolved</button>
                    </div>

                    <div className="row pt-4">
                        <div className="col-12 col-md-8">
                            <div className="row text-md">
                                <div className="col-12 col-sm-4"><h6>Rep 1</h6>
                                    <div>{this.state.opportunity.Rep_1_Name__c}</div>
                                    {
                                        this.state.isEditingCustomer ?
                                        (
                                            <div className="font-weight-bold">
                                                <select name="rep1SetterCloser" id="rep1SetterCloser" onChange={(event) => this.setState({rep1SetterCloser: event.target.value})}>
                                                    <option value="" disabled selected hidden>Rep 1 Setter/Closer?</option>
                                                    <option value="Setter">Setter</option>
                                                    <option value="Closer">Closer</option>
                                                    <option value="HIS Signer">HIS Signer</option>
                                                </select>
                                            </div>
                                        )
                                        :
                                        (
                                            <div>{this.state.opportunity.Sales_Rep_1_Setter_Closer__c ? this.state.opportunity.Sales_Rep_1_Setter_Closer__c : '---'}</div>
                                        )
                                    }
                                </div>
                                <div className="col-12 col-sm-4"><h6>Rep 2</h6>
                                    <div>{this.state.opportunity.Rep_2_Name__c ? this.state.opportunity.Rep_2_Name__c : '---'}</div>
                                    {
                                        this.state.isEditingCustomer ?
                                        (
                                            <div className="font-weight-bold">
                                                <select name="rep2SetterCloser" id="rep2SetterCloser" onChange={(event) => this.setState({rep2SetterCloser: event.target.value})}>
                                                    <option value="" disabled selected hidden>Rep 2 Setter/Closer?</option>
                                                    <option value="Setter">Setter</option>
                                                    <option value="Closer">Closer</option>
                                                    <option value="HIS Signer">HIS Signer</option>
                                                </select>
                                            </div>
                                        )
                                        :
                                        (
                                            <div>{this.state.opportunity.Sales_Rep_2_Setter_Closer__c ? this.state.opportunity.Sales_Rep_2_Setter_Closer__c : '---'}</div>
                                        )
                                    }
                                </div>
                                <div className="col-12 col-sm-4"><h6>Rep 3</h6>
                                    <div>{this.state.opportunity.Rep_3_Name__c ? this.state.opportunity.Rep_3_Name__c : '---'}</div>
                                    {
                                        this.state.isEditingCustomer ?
                                        (
                                            <div className="font-weight-bold">
                                                <select name="rep3SetterCloser" id="rep3SetterCloser" onChange={(event) => this.setState({rep3SetterCloser: event.target.value})}>
                                                    <option value="" disabled selected hidden>Rep 3 Setter/Closer?</option>
                                                    <option value="Setter">Setter</option>
                                                    <option value="Closer">Closer</option>
                                                    <option value="HIS Signer">HIS Signer</option>
                                                </select>
                                            </div>
                                        )
                                        :
                                        (
                                            <div>{this.state.opportunity.Sales_Rep_3_Setter_Closer__c ? this.state.opportunity.Sales_Rep_3_Setter_Closer__c : '---'}</div>
                                        )
                                    }
                                </div>
                            </div>

                            {/* ----- Customer Details Form: ----- */}
                            <div className="mt-5">
                                <h2>Customer Details</h2>
                                    {
                                        this.state.isEditingCustomer ?
                                            // if in customer edit mode:
                                            (
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="font-weight-bold">
                                                            {/* see <https://flatpickr.js.org/formatting/> for date formatting */}
                                                            <Flatpickr
                                                                className="w-100"
                                                                data-enable-time
                                                                options={{
                                                                    dateFormat: 'n/j/Y h:iK'
                                                                }}
                                                                value={this.state.postAppointmentTime}
                                                                onChange={date => {
                                                                    this.setState({ postAppointmentTime: date });
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="text-sm">Post Appointment Time</div>
                                                        {
                                                            this.state.patError ? 
                                                            <div className='text-danger text-uppercase'>Error</div>
                                                            :
                                                            ''
                                                        }
                                                    </div>
                                                    <div className="col-md-6 mt-3 mt-md-0">
                                                        <div className="font-weight-bold">
                                                            {/* see <https://flatpickr.js.org/formatting/> for date formatting */}
                                                            <Flatpickr
                                                                className="w-100"
                                                                data-enable-time
                                                                options={{
                                                                    dateFormat: 'n/j/Y h:iK'
                                                                }}
                                                                value={this.state.postAppointmentCompleted}
                                                                onChange={date => {
                                                                    this.setState({ postAppointmentCompleted: date });
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="text-sm">Post Appointment Completed</div>
                                                    </div>
                                                </div>
                                            )
                                            :
                                            // if in customer display mode:
                                            (
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                                            {/* N.b. we don't use `formatShortDate` since the date formatting is different (has time):`  */}
                                                            {this.state.opportunity.Post_Appointment_Time__c ? moment(this.state.opportunity.Post_Appointment_Time__c).format('MM/D/YY h:mmA') : '---'}
                                                        </div>
                                                        <div className="text-sm">Post Appointment Time</div>
                                                    </div>
                                                    <div className="col-md-6 mt-3 mt-md-0">
                                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                                            {this.state.opportunity.Post_Appointment_Completed_DT__c ? moment(this.state.opportunity.Post_Appointment_Completed_DT__c).format('MM/D/YY h:mmA') : '---'}
                                                        </div>
                                                        <div className="text-sm">Post Appointment Completed</div>
                                                    </div>
                                                </div>
                                            )
                                    }
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}><a className='text-primary' href={`https://www.google.com/maps/place/${this.state.opportunity.Street__c}+${this.state.opportunity.City__c}+${this.state.opportunity.State__c}+${this.state.opportunity.Zip__c}`} target="_blank" rel="noreferrer noopener">{this.state.opportunity.Street__c}</a></div>
                                        <div className="text-sm">Street</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.City__c}</div>
                                        <div className="text-sm">City</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.State__c}</div>
                                        <div className="text-sm">State</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.Zip__c}</div>
                                        <div className="text-sm">Zip Code</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                            <a href={`mailto:${this.state.customerPreferredEmail}`}>
                                                {this.state.customerPreferredEmail}
                                            </a>
                                        </div>
                                        <div className="text-sm">Email</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                            <a href={`tel:${this.state.customerPhone}`}>
                                                {this.state.customerPhone}
                                            </a>
                                        </div>
                                        <div className="text-sm">Phone</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                            <a href={`tel:${this.state.customerPhone2}`}>
                                                {this.state.customerPhone2}
                                            </a>
                                        </div>
                                        <div className="text-sm">Secondary Phone</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        {
                                            this.state.isEditingCustomer ?
                                            (
                                                <div className="font-weight-bold">
                                                    {/* see <https://flatpickr.js.org/formatting/> for date formatting */}
                                                    <Flatpickr
                                                        className="w-100"
                                                        data-enable-time
                                                        options={{
                                                            dateFormat: 'n/j/Y h:iK'
                                                        }}
                                                        value={this.state.Cancel_Survey_Request__c}
                                                        onChange={date => {
                                                            this.setState({ cancelSurveyRequest: date });
                                                        }}
                                                    />
                                                </div>
                                            ) :
                                            (
                                                <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                                    {/* N.b. we don't use `formatShortDate` since the date formatting is different (has time):`  */}
                                                    {this.state.opportunity.Cancel_Survey_Request__c ? moment(this.state.opportunity.Cancel_Survey_Request__c).format('MM/D/YY h:mmA') : '---'}
                                                </div>
                                            )
                                        }
                                        <div className="text-sm">Cancel Survey Request</div>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                    {this.state.isEditingCustomer ? 
                                    (
                                        <select className="form-control" multiple value={this.state.customerType} 
                                            onChange={(event) => {
                                            const values = Array.from(event.target.selectedOptions, (opt) => opt.value);
                                            this.setState({ customerType: values });
                                          }}>
                                            { this.state.customerTypeOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                                        </select>
                                    ) : (
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.customerType ? this.state.customerType.join(', ') : '---'}</div>
                                    )}
                                        <div className="text-sm">Customer Type</div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.nextStep ? this.state.nextStep : '---'}</div>
                                        <div className="text-sm">Next Step</div>
                                    </div>
                                </div>
                            </div>

                            {/* Deal Documents */}
                            <h2 className='mt-4' onClick={() => this.setState({showDealDocs: !this.state.showDealDocs})}>Deal Documents {this.state.showDealDocs ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                            <div className={this.state.showDealDocs ?'row':'d-none'}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="w-50">Credit Checked</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('credit') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Title Verification</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('title') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Usage</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('usage') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">CPUC</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('cpuc') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Agreement</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('agreement') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Scheduled Site Survey</td>
                                            <td className="w-50 font-weight-bold">{this.state.dealDoc.get('survey') ? <FontAwesomeIcon className='text-green' icon={faCheck}/> : '---'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Signed Prelim Proposal */}
                            <h2 className='mt-4' onClick={() => this.setState({showPrelimProp: !this.state.showPrelimProp})}>Signed Prelim Proposal {this.state.showPrelimProp ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                            <div className={this.state.showPrelimProp ?'row':'d-none'}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="w-50">kWh Rate</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Price_per_kWh__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(this.state.prelimProp.Price_per_kWh__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">PPW</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Price_per_Watt__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProp.Price_per_Watt__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Net EPC</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.EPC__c ? Intl.NumberFormat({minimumFractionDigits: 3}).format(this.state.prelimProp.EPC__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Battery Monthly Payment</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Monthly_Battery_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProp.Monthly_Battery_Amount__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Solar Monthly Payment</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Monthly_Bill_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProp.Monthly_Bill_Amount__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Total Monthly Payment</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Total_Monthly_Payment__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProp.Total_Monthly_Payment__c) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">System Size</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.System_Size__c ? this.state.prelimProp.System_Size__c : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Panel Count</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Post_Panel_Count__c ? this.state.prelimProp.Post_Panel_Count__c : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Escalator</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Escalator__c ? this.state.prelimProp.Escalator__c + '%' : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Offset</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Offset__c ? this.state.prelimProp.Offset__c + '%' : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Est. Year One Prod</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Est_Year_One_Production__c ? (this.state.prelimProp.Est_Year_One_Production__c).toFixed(0) : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Annual Usage</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Annual_Usage__c ? this.state.prelimProp.Annual_Usage__c : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Num of Batteries</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Number_of_Batteries__c ? this.state.prelimProp.Number_of_Batteries__c : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Battery Type</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Battery_Type__c && this.state.prelimProp.Battery_Type__r.Name ? this.state.prelimProp.Battery_Type__r.Name : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Financier</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Financing_Partner__c ? this.state.prelimProp.Financing_Partner__c : "---"}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Type</td>
                                            <td className="w-50 font-weight-bold">{this.state.prelimProp.Type__c ? this.state.prelimProp.Type__c : "---"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h2 className="mt-4" onClick={() => this.setState({ showOfficeRequests: !this.state.showOfficeRequests })}>
                                Office Requests <FontAwesomeIcon className="text-primary" icon={this.state.showOfficeRequests ? faCaretDown : faCaretUp}/>
                            </h2>

                            <div className={this.state.showOfficeRequests ? "" : 'd-none'}>
                                {this.state.visibleOfficeRequests.map((req) => {
                                    return (
                                        <div key={req.id} className="mt-4 p-2 border rounded" id={req.id}>
                                            <h2 onClick={() => this.toggleVisibleOfficeRequest(req.id)} style={{ cursor: 'pointer' }}>
                                                <FontAwesomeIcon className="text-primary" icon={req.extended ?  faChevronDown : faChevronRight} />
                                                {' '}{req.name}{' - '}<span className={req.statusColor}>{req.status}</span>
                                            </h2>
                                            {req.extended && (
                                                <div>
                                                    <div className="small text-black-50 mb-1">
                                                        <b>Request Notes:</b>
                                                    </div>
                                                    <div className="mt-1 small text-black-50 mb-3" style={{ whiteSpace: 'pre-line' }}>
                                                        {req.requestNotes}
                                                    </div>
                                                    {req.fields && (
                                                        <table>
                                                            <tbody>
                                                                {req.fields.map((field) => (
                                                                    <tr>
                                                                        <td className="w-50">{field.name}</td>
                                                                        <td className="w-50 font-weight-bold">
                                                                            {field.value ? field.value : "---"}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                    <button className={req.disregardDisabled ? "d-none" : "btn btn-primary"} onClick={() => this.disregardOfficeRequest(req)}>Disregard Request</button>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>

                            {/* Post Proposal Section*/}
                            <h2
                            className="mt-4"
                            onClick={() => this.setState({ showPostProp: !this.state.showPostProp })}
                            >
                            Post Proposal
                            {this.state.showPostProp ? (
                                <FontAwesomeIcon className="text-primary" icon={faCaretDown} />
                            ) : (
                                <FontAwesomeIcon className="text-primary" icon={faCaretUp} />
                            )}
                            </h2>

                            <div className={this.state.showPostProp ? "" : 'd-none'}>
                            {this.state.visiblePostProposals &&
                                this.state.visiblePostProposals.map((proposal) => (
                                <div key={proposal.Id}>
                                    <h2 className="mt-4" onClick={() => this.toggleProposal(proposal.Id)} style={{ cursor: 'pointer' }}>
                                        <div style={proposal.Active__c ? { fontWeight: 'bold' } : {}}>
                                            {proposal.opened ? (<FontAwesomeIcon className="text-primary" icon={faCaretDown} />) : (<FontAwesomeIcon className="text-primary" icon={faCaretUp} />)}
                                            {' '}
                                            {proposal.Active__c && " (active)"} {proposal.Proposal_Naming_Details__c ? proposal.Proposal_Naming_Details__c : proposal.Name}
                                        </div>
                                    </h2>
                                    {proposal.opened && (
                                    <div>
                                        <table>
                                        <tbody>
                                            <tr>
                                              <td className="w-50">kWh Rate</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Price_per_kWh__c ? Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 3 }).format(proposal.Price_per_kWh__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">PPW</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Price_per_Watt__c ? Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(proposal.Price_per_Watt__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Net EPC</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.EPC__c ? Intl.NumberFormat('en-US', { minimumFractionDigits: 3 }).format(proposal.EPC__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Battery Monthly Payment</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Monthly_Battery_Amount__c ? Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(proposal.Monthly_Battery_Amount__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Solar Monthly Payment</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Monthly_Bill_Amount__c ? Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(proposal.Monthly_Bill_Amount__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Total Monthly Payment</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Total_Monthly_Payment__c ? Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(proposal.Total_Monthly_Payment__c) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">System Size</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.System_Size__c ? proposal.System_Size__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Panel Count</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Post_Panel_Count__c ? proposal.Post_Panel_Count__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Escalator</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Escalator__c ? proposal.Escalator__c + '%' : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Offset</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Offset__c ? proposal.Offset__c + '%' : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Est. Year One Prod</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Est_Year_One_Production__c ? proposal.Est_Year_One_Production__c.toFixed(0) : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Annual Usage</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Annual_Usage__c ? proposal.Annual_Usage__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Num of Batteries</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Number_of_Batteries__c ? proposal.Number_of_Batteries__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Battery Type</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Battery_Type__c && proposal.Battery_Type__r.Name ? proposal.Battery_Type__r.Name : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Financier</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Financing_Partner__c ? proposal.Financing_Partner__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Type</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Type__c ? proposal.Type__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Adders</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Proposal_Adders__c ? proposal.Proposal_Adders__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Missing Documents</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Deal_Documents__r?.Missing_Deal_Docs_for_Dashboard__c ? proposal.Deal_Documents__r.Missing_Deal_Docs_for_Dashboard__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Notes from OA</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Proposal_Notes_to_Rep__c ? proposal.Proposal_Notes_to_Rep__c : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Completed Date</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.Proposal_Complete__c ? moment(proposal.Proposal_Complete__c).format('MM/DD/YYYY hh:mm a') : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="w-50">Created By</td>
                                              <td className="w-50 font-weight-bold">
                                                {proposal.CreatedBy.Name ? proposal.CreatedBy.Name : "---"}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {proposal.documents && proposal.documents.length > 0 && (
                                        <div className="mt-3">
                                            {/* At Shane's request, naming it “Attachments” to avoid confusing the reps. */}
                                            <h3>Attachments</h3>
                                            <table>
                                            <tbody>
                                                {proposal.documents.map((doc, index) => (
                                                <tr key={index}>
                                                    <td className="font-weight-bold">
                                                        <a href={doc.key} target="_blank" rel="noopener noreferrer">
                                                            {doc.type}
                                                        </a>
                                                    </td>
                                                    <td>{doc.name}</td>
                                                </tr>
                                                ))}
                                            </tbody>
                                            </table>
                                        </div>
                                        )}
                                    </div>
                                    )}
                                </div>
                                ))}
                            </div>

                            {/* ----- Additional Work: ----- */}
                            <div className={
                                (this.state.ewMeterSpotRqd ||
                                this.state.opportunity.HOA_Needed__c ||
                                this.state.opportunity.Contract_Work_Needed__c)
                                ?
                                'mt-4'
                                :
                                'd-none'
                            }>
                                <h2 onClick={() => this.setState({showAddWork: !this.state.showAddWork})}>Additional Work {this.state.showAddWork ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                                <div className={this.state.showAddWork ?'row':'d-none'}>
                                    <div className={this.state.ewMeterSpotRqd ? 'col-md-6' : 'd-none'}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>Meter Spot Needed</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.ewMeterSpotRqd)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Reason for Meter Spot</td>
                                                <td className="font-weight-bold">{this.state.opportunity.Upgrade_Derate__c}</td>
                                            </tr>
                                            <tr>
                                                <td>Meter Spot Submitted</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.ewMeterSpotSub)}
                                                </td>
                                            </tr>
                                            <tr className={(this.state.opportunity.Upgrade_Derate__c === 'Upgrade') ? '' : 'd-none'}>
                                                <td>Appointment to Complete Upgrade</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.Disco_Reco_Start__c)}
                                                </td>
                                            </tr>
                                            <tr className={(this.state.opportunity.Upgrade_Derate__c === 'Derate') ? '' : 'd-none'}>
                                                <td>Appointment to Complete Derate</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.Meter_Pull_Start__c)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Meter Spot Completed</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.ewMeterSpotCom)}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className={this.state.opportunity.HOA_Needed__c ? 'col-md-6' : 'd-none'}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>HOA Approval Needed</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.HOA_Needed__c)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>HOA Applied</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.hoaApplied)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>HOA Approval Granted</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.HOA_Approval__c)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>HOA Contact Info</td>
                                                <td className="font-weight-bold">
                                                    {this.state.hoaContactInfo}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className={this.state.showAddWork ?'row':'d-none'}>
                                    <div className={this.state.opportunity.Contract_Work_Needed__c ? 'col-md-6' : 'd-none'}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>Contract Work Needed</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.Contract_Work_Needed__c)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Contractor Contacted</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.Contract_Work_Requested__c)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Contract Work Completed</td>
                                                <td className="font-weight-bold">
                                                    {formatShortDate(this.state.opportunity.Contract_Work_Completed__c)}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* ----- Project Details: ----- */}
                            <div className={`${css.CustomerDetails__ProjectDetails} mt-4`}>
                                <h2 onClick={() => this.setState({showProjectDetails: !this.state.showProjectDetails})}>Project Details {this.state.showProjectDetails ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                                <div className={this.state.showProjectDetails ?'row':'d-none'}>
                                    <div className="col-12">
                                        <table>
                                            {/* for the "Project Details" section, the first <tr> serves as the row heading in mobile: */}
                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">SITE SURVEY</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="2">SITE SURVEY</td>
                                                    <td>Site Survey Scheduled</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Site_Survey_Start__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Site Survey Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Site_Survey_Completed__c)}
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">DESIGN/PERMIT</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="4">DESIGN/PERMIT</td>
                                                    <td>Ready for Design</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Ready_for_Design_Date__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Design Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Design_Complete__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Permit Submitted</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Permit_Submitted__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Permit Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Permit_Complete__c)}
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">INSTALL</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="4">INSTALL</td>
                                                    <td>Install Scheduled</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Install_Scheduled_Start__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Solar Tie In Complete</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Electrical_Install_Completed__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Roof Install Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Roof_Install_Completed__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Install Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Install_Complete__c)}
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">INSPECTION</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="2">INSPECTION</td>
                                                    <td>Inspection Scheduled</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Inspection_Scheduled_Start__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Inspection Complete</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Inspection_Passed__c)}
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">INTERCONNECTION</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="6">INTERCONNECTION</td>
                                                    <td>NEM Forms Sent</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.NEM_Forms_Sent__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>NEM Forms Signed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.NEM_Signed_Date__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Approval To Build Submitted</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Approval_to_Build_Submitted__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Approval To Build Received</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Approval_to_Build_Received__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Submitted for Interconnection</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Submitted_for_Interconnection__c)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Interconnection Date</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Interconnection_Date__c)}
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody>
                                                <tr className="d-sm-none"><td className="font-weight-bold" colSpan="2">REVISIONS / NEEDED APPROVALS</td></tr>
                                                <tr>
                                                    <td className="d-none d-sm-table-cell" rowSpan="7">REVISIONS / NEEDED APPROVALS</td>
                                                    <td>Pre-Permit Design Revision Needed</td>
                                                    <td className="font-weight-bold">
                                                        {this.state.opportunity.Design_Revision_Needed_Pre_Permit__c ? 'Yes' : 'No'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Post-Permit Design Revision Needed</td>
                                                    <td className="font-weight-bold">
                                                        {this.state.opportunity.Design_Revision_Needed_Post_Permit__c ? 'Yes' : 'No'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Electrical Approval Needed</td>
                                                    <td className="font-weight-bold">
                                                        {this.state.opportunity.Electrical_Approval_Needed__c ? 'Yes' : 'No'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Install Approval Needed</td>
                                                    <td className="font-weight-bold">
                                                        {this.state.opportunity.Install_Manager_Approval_Needed__c ? 'Yes' : 'No'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Post-Permit Revision Needed</td>
                                                    <td className="font-weight-bold">
                                                        {this.state.opportunity.Post_Permit_Revision_Required__c ? 'Yes' : 'No'}
                                                    </td>
                                                </tr>
                                                <tr className={this.state.opportunity.Post_Install_Revision_Required__c ? '' : 'd-none'}>
                                                    <td>Post-Permit Revision Submitted</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Post_Permit_Revision_Submitted__c)}
                                                    </td>
                                                </tr>
                                                <tr className={this.state.opportunity.Post_Install_Revision_Required__c ? '' : 'd-none'}>
                                                    <td>Post-Permit Revision Completed</td>
                                                    <td className="font-weight-bold">
                                                        {formatShortDate(this.state.opportunity.Post_Permit_Revision_Completed__c)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* ----- Financier Milestones: ----- */}
                            <div className="mt-4">
                                <h2 onClick={() => this.setState({showMilestones: !this.state.showMilestones})}>Financier Milestones {this.state.showMilestones ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                                <div className={this.state.showMilestones ?'row':'d-none'}>
                                    <table>
                                        <tbody>
                                        <tr className={(this.state.opportunity.Company__c === 'SunRun') ? '' : 'd-none'}>
                                            <td>Deal Approval Submitted</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.Deal_Approval_Submitted__c)}
                                            </td>
                                        </tr>
                                        <tr className={(this.state.opportunity.Company__c === 'SunRun') ? '' : 'd-none'}>
                                            <td>Deal Approval Approved</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.Deal_Approval_Approved__c)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Submitted for NTP</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.NTP_Submitted__c)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>NTP Completion</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.NTP_Completion__c)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Substantial Completion</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.Substantial_Completion__c)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Final Completion</td>
                                            <td className="font-weight-bold">
                                                {formatShortDate(this.state.opportunity.Final_Completion__c)}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* ----- Opp Notes: ----- */}
                            <div className="mt-5">
                                <h2>Opp Notes</h2>
                                <textarea maxLength={4000} defaultValue={this.state.opportunity.Sales_Notes__c} onChange={(event) => this.setState({oppNotes: event.target.value})} rows="10"></textarea>
                                <button className="btn btn-primary" disabled={this.state.oppNotesDisabled} onClick={this.saveOppNotes}>Save Notes</button>
                                {
                                    this.state.oppNoteSaveSuccess ? 
                                    <p>&nbsp;&nbsp;&nbsp;Saved Successfully</p>
                                    :
                                    ''
                                }
                            </div>

                            {/* ----- Attempts ----- */}
                            {/* <div className="mt-4">
                                <h2 onClick={() => this.setState({showAttempts: !this.state.showAttempts})}>Attempts {this.state.showAttempts ? <FontAwesomeIcon className='text-primary' icon={faCaretDown}/> : <FontAwesomeIcon className='text-primary' icon={faCaretUp}/>}</h2>
                                <div className={this.state.showAttempts ?'row':'d-none'}>
                                    <table className={this.state.attempts.length ? css.CustomerDetails__AttemptsTable : 'd-none'}>
                                        <thead>
                                            <tr>
                                                <th>Type</th>
                                                <th>Date</th>
                                                <th>Outcome</th>
                                                <th>Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.attempts.map(attempt => {
                                                return (
                                                    <tr key={attempt.Id}>
                                                        <td>{attempt.Type__c}</td>
                                                        <td>{moment(attempt.CreatedDate).format('MM/DD/YYYY @ hh:mmA')}</td>
                                                        <td>{attempt.Call_Outcome__c}</td>
                                                        <td>{attempt.Notes__c}</td>
                                                    </tr>
                                                );
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div> */}
                        </div>

                        {/* ---------- Messages: ---------- */}
                        <div className="col-12 col-md-4">
                            <div className="mt-4 mb-1">Write A Message</div>
                            <Formik
                                initialValues={{
                                    message: '',
                                    group: [] // checkboxes of 'group' tags
                                }}

                                validate={
                                    (values)=> {
                                        const errors = {};

                                        if (!values.group.length) {
                                            errors.group = 'You Must Select a Group to Tag';
                                        }

                                        if(values.message === '') {
                                            errors.message = 'Message Is Blank'
                                        }

                                        return errors;
                                    }
                                }

                                onSubmit={
                                    // n.b. this method is an exact copy as the one in LeadDetails:
                                    (values, { resetForm }) => {
                                        this.setState({disableSubmit: true});

                                        setTimeout(() => this.setState({disableSubmit: false}), 5000);
                                        // convert checked values to list of boolean values:
                                        const mention = this.messageGroupTypes.map(groupType => values.group.includes(groupType));

                                        const message = `${this.props.user.name} -- \n${values.message.trim()} `;

                                        const payload = {
                                            message,
                                            id: this.customerId,
                                            mention,
                                        };

                                        axios.post(
                                            '/sf/chatter/message',
                                            payload,
                                            {
                                                cancelToken: this.source.token
                                            })
                                            .then((res) => {
                                                // fetch updated chatter:
                                                this.setState({
                                                    chatter: [res.data, ...this.state.chatter]
                                                });

                                                // clear form:
                                                resetForm();
                                            });
                                    }
                                }
                            >
                                <Form>
                                    <Field name="message" rows="8" as="textarea" />
                                    <ErrorMessage name="message" component={ErrorLabel} />

                                    {/* ----- checkboxes: ----- */}
                                    <div>
                                        {
                                            this.messageGroupTypes.map(group => {
                                                return (
                                                    <div key={group}>
                                                        <Field className="mr-2" name="group" value={group} type="checkbox"/>
                                                        <span>Tag <span className="font-weight-bold">{group}</span> Team</span>
                                                    </div>
                                                );
                                            })
                                        }
                                        <div className="mt-2">
                                            <ErrorMessage name="group" component={ErrorLabel} />
                                        </div>
                                    </div> {/* /checkboxes section */}
                                    <div className="text-right mt-2">
                                        <button className="btn btn-primary" type="submit" disabled={this.state.disableSubmit}>Submit</button>
                                    </div>
                                </Form>
                            </Formik>

                            {/* ----- chatter: ----- */}
                            <div className={css.CustomerDetails__Chatter}>
                                {
                                    this.state.chatter.map(chat => {
                                        return (
                                            <div key={chat.id} className={chat.body.text ? 'mt-5' : 'd-none'}>
                                                <h2>Comment</h2>
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-primary">{chat.actor ? chat.actor.displayName : ''}</div>
                                                    <div className="text-primary">{moment(chat.createdDate).format('MM/DD/YYYY hh:mm a')}</div>
                                                </div>
                                                <div className="my-3">
                                                    {/* n.b. we must decode HTML entities to prevent XSS: */}
                                                    {
                                                        he.decode(chat.body.text).includes('\n')  ?
                                                        <p>
                                                            {this.splitString(he.decode(chat.body.text)).map(s => {
                                                                return (
                                                                    <span key={s}>{s}<br></br></span>
                                                                );
                                                            })}
                                                        </p>
                                                        :
                                                        <span>
                                                            {he.decode(chat.body.text || '')}
                                                        </span>
                                                    }
                                                </div>

                                                {/* ----- comments: ----- */}
                                                {
                                                    // we need to guard against non-existent properties -- which would throw an error:
                                                    (
                                                        chat.capabilities &&
                                                        chat.capabilities.comments &&
                                                        chat.capabilities.comments.page &&
                                                        chat.capabilities.comments.page.items.length
                                                    )
                                                        ?
                                                        (
                                                            <div className={`${css.CustomerDetails__Comments} ml-3`}>
                                                                {
                                                                    chat.capabilities.comments.page.items.map(comment => {
                                                                        return (
                                                                            <div key={comment.id} className={
                                                                                (
                                                                                    comment.user.displayName === 'System Admin' &&
                                                                                    !comment.body.text.includes(this.props.user.name)
                                                                                )
                                                                                    ?
                                                                                    ''
                                                                                    :
                                                                                    'text-green'
                                                                            }>
                                                                                {/* n.b. we must decode HTML entities to prevent XSS: */}
                                                                                {
                                                                                    he.decode(comment.body.text).includes("\n") ?
                                                                                    
                                                                                    <div>
                                                                                        {he.decode(comment.user.name)}--<br></br>
                                                                                        {this.splitString(he.decode(comment.body.text)).map(s => {
                                                                                            return (
                                                                                                <span key={s}>{s}<br></br></span>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                    :
                                                                                    <span>
                                                                                        {he.decode(comment.user.name)}-- { he.decode(comment.body.text)  }
                                                                                    </span>
                                                                                }
                                                                                <p className="my-3">{moment(comment.createdDate).format('MM/DD/YYYY hh:mm a')}</p>
                                                                            </div>
                                                                        );
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                        :
                                                        null
                                                }

                                                {/* ----- reply to message: ----- */}
                                                <div className="ml-3">
                                                    <Accordion
                                                        header={<span>Reply</span>}
                                                        content={
                                                            <div>
                                                                <div>Reply</div>
                                                                <Formik
                                                                    initialValues={{
                                                                        reply: ''
                                                                    }}

                                                                    onSubmit={
                                                                        (values, { resetForm }) => {
                                                                            this.setState({disableSubmit: true});

                                                                            setTimeout(() => this.setState({disableSubmit: false}), 5000);
                                                                            
                                                                            const payload = {
                                                                                id: chat.id,
                                                                                message: `${this.props.user.name} -- ${values.reply.trim()}`
                                                                            };

                                                                            axios.post(
                                                                                '/sf/chatter/comment',
                                                                                payload,
                                                                                {
                                                                                    cancelToken: this.source.token
                                                                                })
                                                                                .then((res) => {
                                                                                    resetForm();
                                                                                    this.getChatter();
                                                                                })
                                                                                .catch(err => console.log('(POST) error while posting comment: \n', err));
                                                                        }
                                                                    }
                                                                >
                                                                    <Form>
                                                                        <Field name="reply" as="textarea" />
                                                                        <div className="text-right mt-2">
                                                                            <button className="btn btn-primary" type="submit" disabled={this.state.disableSubmit}>Submit</button>
                                                                        </div>
                                                                    </Form>
                                                                </Formik>
                                                            </div>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div> {/* /chatter section */}
                        </div> {/* /messages section */}
                    </div> {/* /.row */}
                </div>

                {/* ---------- Log Attempt Modal: ---------- */}
                <Modal
                    isOpen={this.state.isModelOpen}
                    onRequestClose={() => this.setState({isModelOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                >
                    <div className="d-flex justify-content-between">
                        <h3>Log Attempt</h3>

                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({isModelOpen: false})} />
                        </span>
                    </div>

                    <div className="mt-3">
                        <label htmlFor="logAttemptType">Type</label>
                        <select id="logAttemptType" value={this.state.logAttemptType} onChange={(event) => this.setState({logAttemptType: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Email">Email</option>
                            <option value="Text">Text</option>
                            <option value="Call">Call</option>
                        </select>
                    </div>

                    <div className={this.state.logAttemptType === 'Call' ? 'mt-3' : 'd-none'}>
                        <label htmlFor="logAttemptOutcome">Call Outcome</label>
                        <select id="logAttemptOutcome" value={this.state.logAttemptOutcome} onChange={(event) => this.setState({logAttemptOutcome: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="No Answer">No Answer</option>
                            <option value="Left VM">Left VM</option>
                            <option value="Contacted">Contacted</option>
                            <option value="Appt Set">Appt Set</option>
                        </select>
                    </div>

                    <div className="mt-3">
                        <label htmlFor="logAttemptNotes">Notes</label>
                        <textarea id="logAttemptNotes" value={this.state.logAttemptNotes} onChange={(event) => this.setState({logAttemptNotes: event.target.value})} />
                    </div>

                    <div className="mt-3 text-right">
                        <button className="btn btn-primary" type="button" onClick={() => this.modalLogAttemptOnClick()}>Save Attempt</button>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.isOfficeRequestModalOpen}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            position: 'relative',
                            maxHeight: 'calc(100vh - 2rem)', // 20vh more than original
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    {this.state.officeRequestLoading && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1000 }}>
                            <FontAwesomeIcon icon={faSpinner} spin size="3x" />
                        </div>
                    )}

                    {/* <div class="position-relative"> */}
                    <div className="d-flex justify-content-between text-white">
                        <h3>Office Request</h3>

                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.closeOfficeRequestModal()} />
                        </span>
                    </div>

                    <div className={css.CustomerDetails__Error}>
                            <p>{this.state.officeRequestModalError}</p>
                    </div>

                    <div className={this.state.officeRequestModalPage === 'locked' ? '' : 'd-none'}>
                        <div className="mt-2 text-white">New revisions cannot be requested after install has been scheduled, please contact your account manager to make changes.</div>
                    </div>

                    <div className={this.state.officeRequestModalPage === 'intro' ? '' : 'd-none'}>
                        <label className="text-white">Are you currently in home with the customer?</label>

                        <div className="form-group">
                            <div className="btn-group btn-group-toggle">
                                <label className={"btn " + (!this.state.inHomeOfficeRequest ? "btn-primary" : "btn-outline-secondary")}
                                        onClick={() => this.setState({inHomeOfficeRequest: false})}>
                                    No
                                </label>
                                <label className={"btn " + (this.state.inHomeOfficeRequest ? "btn-primary" : "btn-outline-secondary")}
                                        onClick={() => this.setState({inHomeOfficeRequest: true })}>
                                    Yes
                                </label>
                            </div>
                        </div>

                        <div className="mt-4 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest('Proposal Request')} checked={this.state.officeRequests.includes('Proposal Request')} className="mr-1"/>
                                Proposal Request
                           </label>
                        </div>
                        
                        <div className="mt-2 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest(this.state.customerInfoChangeTask.subject)} checked={this.state.officeRequests.includes(this.state.customerInfoChangeTask.subject)} className="mr-1"/>
                                {this.state.customerInfoChangeTask.subject}
                            </label>
                        </div>

                        <div className="mt-2 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest(this.state.signerChangeTask.subject)} checked={this.state.officeRequests.includes(this.state.signerChangeTask.subject)} className="mr-1"/>
                                {this.state.signerChangeTask.subject}
                            </label>
                        </div>

                        <div className="mt-2 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest(this.state.sendAgreementTask.subject)} checked={this.state.officeRequests.includes(this.state.sendAgreementTask.subject)} className="mr-1"/>
                                {this.state.sendAgreementTask.subject}
                            </label>
                        </div>

                        <div className="mt-2 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest(this.state.salesRepChangeTask.subject)} checked={this.state.officeRequests.includes(this.state.salesRepChangeTask.subject)} className="mr-1"/>
                                {this.state.salesRepChangeTask.subject}
                            </label>
                        </div>

                        <div className="mt-2 text-white">
                            <label>
                                <input type="checkbox" onChange={() => this.toggleOfficeRequest(this.state.otherOfficeRequestTask.subject)} checked={this.state.officeRequests.includes(this.state.otherOfficeRequestTask.subject)} className="mr-1"/>
                                {this.state.otherOfficeRequestTask.subject}
                            </label>
                        </div>
                    </div>

                    <div className={this.state.officeRequestModalPage === 'selection' ? '' : 'd-none'}>
                        <div className={this.state.officeRequests.includes('Proposal Request') ? "mt-2 text-white" : 'd-none'}>
                            <label>Proposal Request</label>

                            <div className="form-group">
                                <div className="btn-group btn-group-toggle">
                                    <label className={"btn " + (this.state.officeRequestProposalType === "Pricing Only" ? "btn-primary" : "btn-outline-secondary")}
                                            onClick={this.officeReqPricingOnly}>
                                        Pricing Only
                                    </label>
                                    <label className={"btn " + (this.state.officeRequestProposalType === "System + Pricing" ? "btn-primary" : "btn-outline-secondary")}
                                            onClick={() => this.setState({ officeRequestProposalType: "System + Pricing" })}>
                                        System + Pricing
                                    </label>
                                </div>
                            </div>

                            {this.state.officeRequestProposals.map((proposal, idx) => (
                            <div key={idx} className="mt-1 mb-1 p-2 border rounded text-white">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => this.toggleProposalExtended(idx)}>
                                            <FontAwesomeIcon icon={proposal.extended ? faChevronDown : faChevronRight} />
                                        </button>
                                        <strong>
                                            Proposal #{idx + 1}
                                            {!this.validateSingleProposal(idx) && <span className="text-danger ml-1">*</span>}
                                        </strong>
                                    </div>
                                    {this.state.officeRequestProposals.length > 1 && (
                                        <button className="btn btn-sm btn-danger" onClick={() => this.removeProposal(idx)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    )}
                                </div>

                                {/* Collapsed description: show all non-empty values */}
                                <div className={!proposal.extended ? 'mt-1 small text-white-50' : 'd-none'}>
                                    {proposal.financier && <div>Financier: {proposal.financier}</div>}
                                    {proposal.financingType && <div>Financing Type: {proposal.financingType}</div>}
                                    {proposal.epc && <div>EPC: {proposal.epc}</div>}
                                    {proposal.monthly && <div>Monthly: ${proposal.monthly}</div>}
                                    {proposal.offset && <div>Offset: {proposal.offset}%</div>}
                                    {proposal.production && <div>Annual Production: {proposal.production}kWh</div>}
                                    {proposal.rate && <div>Rate: {proposal.rate}¢</div>}
                                    {proposal.escalator && <div>Escalator: {proposal.escalator}%</div>}
                                    {proposal.layoutNotes && <div>Layout Notes: {proposal.layoutNotes}</div>}
                                    {proposal.batteryType && <div>Battery Type: {proposal.batteryType}</div>}
                                    {proposal.batteryQuantity && <div>Battery Quantity: {proposal.batteryQuantity}</div>}
                                    {proposal.notes && <div>Additional Notes: {proposal.notes}</div>}
                                    {proposal.priorities && proposal.priorities.length > 0 && (
                                    <div>Priorities: 
                                        {proposal.priorities.map((p, i) => (
                                            <span key={p}>
                                                {/* will need to test, this might not work when pushed to staging */}
                                                {i > 0 && ', '} #{i + 1}: {p}
                                            </span>
                                        ))}
                                    </div>
                                    )}
                                </div>

                                {proposal.extended && (
                                <div className="mt-2">
                                    <div className="mt-1 small text-white-50 mb-2">Fill in only the items you want to change from the previous proposal.</div>
                                    <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Financier</label>
                                        <select value={proposal.financier} onChange={e => this.updateProposalField(idx, 'financier', e.target.value)} className="form-control">
                                            <option value="">Select one…</option>
                                            {this.state.financingPartners.map(option => (
                                                <option key={option.value} value={option.value}> {option.label} </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Financing Type</label>
                                        <select  value={proposal.financingType} onChange={e => this.updateProposalField(idx, 'financingType', e.target.value)} className="form-control">
                                            <option value="">Select one…</option>
                                            {this.state.financingTypes.map(option => (
                                                <option key={option.value} value={option.value}> {option.label} </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>EPC</label>
                                        <input type="number" className="form-control" value={proposal.epc} placeholder="Enter EPC" onChange={e => this.updateProposalField(idx, 'epc', e.target.value)}></input>
                                    </div>

                                    <div className="form-group">
                                        <label>Monthly ($)</label>
                                        <input type="number" className="form-control" value={proposal.monthly} placeholder="$ amount" onChange={e => this.updateProposalField(idx, 'monthly', e.target.value)}/>
                                    </div>

                                    <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Offset (%)</label>
                                        <input type="number" className="form-control" value={proposal.offset} placeholder="% offset" onChange={e => this.updateProposalField(idx, 'offset', e.target.value)}/>
                                    </div>

                                    <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Annual Production (kWh)</label>
                                        <input type="number" className="form-control" value={proposal.production} placeholder="$ production" onChange={e => this.updateProposalField(idx, 'production', e.target.value)}/>
                                    </div>

                                    <div className="form-group">
                                        <label>Rate (¢)</label>
                                        <input type="number" className="form-control" value={proposal.rate} placeholder="cents" onChange={e => this.updateProposalField(idx, 'rate', e.target.value)}/>
                                    </div>

                                    <div className="form-group">
                                        <label>Escalator (%)</label>
                                        <input type="number" className="form-control" value={proposal.escalator} placeholder="% per year" onChange={e => this.updateProposalField(idx, 'escalator', e.target.value)}/>
                                    </div>

                                    {/* Would be great if this can be made bigger to be more user frindly */}
                                    <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Layout Notes</label>
                                        <input type="text" className="form-control" value={proposal.layoutNotes} placeholder="Any layout specifics…" onChange={e => this.updateProposalField(idx, 'layoutNotes', e.target.value)}/>
                                    </div>

                                    <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Battery Type</label>
                                        <select value={proposal.batteryType} onChange={e => this.updateProposalField(idx, 'batteryType', e.target.value)} className="form-control">
                                            {/* this is not the first time these options are hardcoded. There should be a better way to do this */}
                                            <option value="">Choose one…</option>
                                            <option value="Tesla Powerwall 3 (AC)">Tesla Powerwall 3</option>
                                            <option value="SolarEdge ESSD (TOU)">SolarEdge ESSD (TOU)</option>
                                            <option value="SolarEdge Home (Back Up)">SolarEdge Home (Back Up)</option>
                                            <option value="Enphase IQ Battery 5P (TOU)">Enphase IQ Battery 5P (TOU)</option>
                                            <option value="Enphase IQ Battery 5P (Back Up)">Enphase IQ Battery 5P (Back Up)</option>
                                        </select>
                                    </div>

                                   <div className={this.state.officeRequestProposalType === 'System + Pricing' ? "form-group" : "d-none"}>
                                        <label>Battery Quantity</label>
                                        <input type="number" className="form-control" value={proposal.batteryQuantity} placeholder="How many?" onChange={e => this.updateProposalField(idx, 'batteryQuantity', e.target.value)}/>
                                    </div>

                                    {/* Would be great if this can be made bigger to be more user frindly */}
                                    <div className="form-group">
                                        <label>Additional Notes</label>
                                        <textarea className="form-control" rows={2} maxLength={255} value={proposal.notes} placeholder="Anything else?" onChange={e => this.updateProposalField(idx, 'notes', e.target.value)}></textarea>
                                        {/* <input type="text" className="form-control" value={proposal.notes} onChange={e => this.updateProposalField(idx, 'notes', e.target.value)}/> */}
                                    </div>

                                    {/* Priorities */}
                                    <div className="form-group">
                                        <label>Priorities</label>
                                        <div>
                                            {proposal.priorities.length > 0 && proposal.priorities.map((p, i) => (
                                                <span key={p}>
                                                    {i > 0 && ', '} #{i + 1}: {p}
                                                </span>
                                            ))}
                                        </div>
                                        <div className="d-flex flex-wrap">
                                            {this.prioritiesOptions.map(option => {
                                            const checked = proposal.priorities.includes(option);
                                            const inputId = `proposal-${idx}-priority-${option}`;
                                            return (
                                                <div key={option} className="form-check mr-4 mb-2">
                                                <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={inputId}
                                                value={option}
                                                checked={checked}
                                                disabled={!checked && proposal.priorities.length >= 3}
                                                onChange={e => {
                                                    const { checked, value } = e.target;
                                                    const filtered = proposal.priorities.filter(v => v !== value);
                                                    const newPriorities = checked ? [...filtered, value] : filtered;
                                                    this.updateProposalField(idx, 'priorities', newPriorities);
                                                }}
                                                />
                                                <label htmlFor={inputId} className="form-check-label">
                                                    {option}
                                                </label>
                                                </div>
                                            );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>
                            ))}

                            {this.state.officeRequestProposals.length < 3 && (
                                <button className="btn btn-primary" onClick={this.addProposal}>Additional Request</button>
                            )}
                        </div>

                        <div className={this.state.officeRequests.includes('Customer Info Change') ? "mt-4 text-white p-2 border rounded" : 'd-none'}>
                            <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => {this.setState(prev => ({customerInfoChangeTask: {...prev.customerInfoChangeTask, extended: !prev.customerInfoChangeTask.extended}}));}}>
                                <FontAwesomeIcon icon={this.state.customerInfoChangeTask.extended ? faChevronDown : faChevronRight} />
                            </button>

                            <label>
                                Customer Info Change
                                {this.state.customerInfoChangeTask.requestNotes?.trim() === '' && <span className="text-danger ml-1">*</span>}
                            </label>
                            <div className={this.state.customerInfoChangeTask.extended ? "" : "d-none"}>
                                <div className="small text-white-50 mt-1">
                                    <b>Current info:</b>
                                </div>
                                <ul className="small text-white-50 mb-3 pl-4">
                                    <li>Customer Name: {this.state.customerName} </li>
                                    <li>Full Address: {this.state.opportunity.Full_Address__c}</li>
                                    <li>Phone Number: {this.state.customerPhone}</li>
                                    <li>Customer Email: {this.state.customerPreferredEmail}</li>
                                    <li>Preferred Contact Method: {this.state.customerPreferredCommunication}</li>
                                </ul>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" rows={3} placeholder="Include your changes here…" onChange={e => {
                                        const requestNotes = e.target.value;
                                        this.setState(prev => ({customerInfoChangeTask: {...prev.customerInfoChangeTask, requestNotes}}));
                                    }}
                                    value={this.state.customerInfoChangeTask.requestNotes}/>
                                </div>
                            </div>
                            <div className={!this.state.customerInfoChangeTask.extended && this.state.customerInfoChangeTask.requestNotes ? "mt-1 small text-white-50 mb-2" : "d-none"}>
                                {this.state.customerInfoChangeTask.requestNotes}
                            </div>
                        </div>

                        <div className={this.state.officeRequests.includes('Signer/Cosigner Change') ? "mt-4 text-white p-2 border rounded" : 'd-none'}>
                            <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => {this.setState(prev => ({signerChangeTask: {...prev.signerChangeTask, extended: !prev.signerChangeTask.extended}}));}}>
                                <FontAwesomeIcon icon={this.state.signerChangeTask.extended ? faChevronDown : faChevronRight} />
                            </button>

                            <label>
                                Signer/Cosigner Change
                                {this.state.signerChangeTask.requestNotes?.trim() === '' && <span className="text-danger ml-1">*</span>}
                            </label>
                            <div className={this.state.signerChangeTask.extended ? "" : "d-none"}>
                                <div className="small text-white-50 mt-1">
                                    <b>Current info:</b>
                                </div>
                                <ul className="small text-white-50 mb-3 pl-4">
                                    <li>Current Signer: {this.state.customerName} </li>
                                    <li>Current Cosigner: {this.state.opportunity.Co_Signer__c}</li>
                                </ul>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" rows={3} placeholder="Include your changes here…" onChange={e => {
                                        const requestNotes = e.target.value;
                                        this.setState(prev => ({signerChangeTask: {...prev.signerChangeTask, requestNotes}}));
                                    }}
                                    value={this.state.signerChangeTask.requestNotes}/>
                                </div>
                            </div>
                            <div className={!this.state.signerChangeTask.extended && this.state.signerChangeTask.requestNotes ? "mt-1 small text-white-50 mb-2" : "d-none"}>
                                {this.state.signerChangeTask.requestNotes}
                            </div>
                        </div>

                        <div className={this.state.officeRequests.includes('Send/Re-send Agreement') ? "mt-4 text-white p-2 border rounded" : 'd-none'}>
                            <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => {this.setState(prev => ({sendAgreementTask: {...prev.sendAgreementTask, extended: !prev.sendAgreementTask.extended}}));}}>
                                <FontAwesomeIcon icon={this.state.sendAgreementTask.extended ? faChevronDown : faChevronRight} />
                            </button>

                            <label>
                                Send/Re-send Agreement
                                {this.state.sendAgreementTask.requestNotes?.trim() === '' && <span className="text-danger ml-1">*</span>}
                            </label>
                            <div className={this.state.sendAgreementTask.extended ? "" : "d-none"}>
                                <div className="small text-white-50 mt-1">
                                    <b>Current info:</b>
                                </div>
                                <ul className="small text-white-50 mb-3 pl-4">
                                    <li>Customer Email: {this.state.customerPreferredEmail}</li>
                                </ul>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" rows={3} placeholder="Include your changes here…" onChange={e => {
                                        const requestNotes = e.target.value;
                                        this.setState(prev => ({sendAgreementTask: {...prev.sendAgreementTask, requestNotes}}));
                                    }}
                                    value={this.state.sendAgreementTask.requestNotes}/>
                                </div>
                            </div>
                            <div className={!this.state.sendAgreementTask.extended && this.state.sendAgreementTask.requestNotes ? "mt-1 small text-white-50 mb-2" : "d-none"}>
                                {this.state.sendAgreementTask.requestNotes}
                            </div>
                        </div>

                        <div className={this.state.officeRequests.includes('Sales Rep Addition/Removal') ? "mt-4 text-white p-2 border rounded" : 'd-none'}>
                            <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => {this.setState(prev => ({salesRepChangeTask: {...prev.salesRepChangeTask, extended: !prev.salesRepChangeTask.extended}}));}}>
                                <FontAwesomeIcon icon={this.state.salesRepChangeTask.extended ? faChevronDown : faChevronRight} />
                            </button>

                            <label>
                                Sales Rep Addition/Removal
                                {this.state.salesRepChangeTask.requestNotes?.trim() === '' && <span className="text-danger ml-1">*</span>}
                            </label>
                            <div className={this.state.salesRepChangeTask.extended ? "" : "d-none"}>
                                <div className="small text-white-50 mt-1">
                                    <b>Current info:</b>
                                </div>
                                <ul className="small text-white-50 mb-3 pl-4">
                                    <li>Sales Representative 1: {this.state.opportunity.Rep_1_Name__c}</li>
                                    <li>Sales Representative 2: {this.state.opportunity.Rep_2_Name__c}</li>
                                    <li>Sales Representative 3: {this.state.opportunity.Rep_3_Name__c}</li>
                                </ul>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" rows={3} placeholder="Include your changes here…" onChange={e => {
                                        const requestNotes = e.target.value;
                                        this.setState(prev => ({salesRepChangeTask: {...prev.salesRepChangeTask, requestNotes}}));
                                    }}
                                    value={this.state.salesRepChangeTask.requestNotes}/>
                                </div>
                            </div>
                            <div className={!this.state.salesRepChangeTask.extended && this.state.salesRepChangeTask.requestNotes ? "mt-1 small text-white-50 mb-2" : "d-none"}>
                                {this.state.salesRepChangeTask.requestNotes}
                            </div>
                        </div>

                        <div className={this.state.officeRequests.includes('Other Office Request') ? "mt-4 text-white p-2 border rounded" : 'd-none'}>
                            <button className="btn btn-sm btn-link text-white p-0 mr-2" onClick={() => {this.setState(prev => ({otherOfficeRequestTask: {...prev.otherOfficeRequestTask, extended: !prev.otherOfficeRequestTask.extended}}));}}>
                                <FontAwesomeIcon icon={this.state.otherOfficeRequestTask.extended ? faChevronDown : faChevronRight} />
                            </button>

                            <label>
                                Other Office Request
                                {this.state.otherOfficeRequestTask.requestNotes?.trim() === '' && <span className="text-danger ml-1">*</span>}
                            </label>
                            <div className={this.state.otherOfficeRequestTask.extended ? "" : "d-none"}>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" rows={3} placeholder="Include your changes here…" onChange={e => {
                                        const requestNotes = e.target.value;
                                        this.setState(prev => ({otherOfficeRequestTask: {...prev.otherOfficeRequestTask, requestNotes}}));
                                    }}
                                    value={this.state.otherOfficeRequestTask.requestNotes}/>
                                </div>
                            </div>
                            <div className={!this.state.otherOfficeRequestTask.extended && this.state.otherOfficeRequestTask.requestNotes ? "mt-1 small text-white-50 mb-2" : "d-none"}>
                                {this.state.otherOfficeRequestTask.requestNotes}
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-between align-items-center text-white">
                        {/* left side */}
                        <div>
                            <button className={this.state.officeRequestModalPage === 'selection' ? 'btn btn-primary mt-3' : 'd-none'} type="button" onClick={() => this.setState({officeRequestModalPage: 'intro'})}>Back</button>
                        </div>

                        {/* right side */}
                        <div>
                            <button 
                                className={this.state.officeRequestModalPage === 'intro' ? 'btn btn-primary mt-3' : 'd-none'} 
                                type="button" onClick={() => this.setState({officeRequestModalPage: 'selection'})} 
                                disabled={!this.state.officeRequests || this.state.officeRequests.length === 0}
                            >
                                Next
                            </button>
                            
                            <button 
                                className={this.state.officeRequestModalPage === 'selection' ? 'btn btn-primary mt-3' : 'd-none'} 
                                type="button" onClick={() => this.submitOfficeRequestOnClick()} 
                                disabled={this.submitOfficeReqDisabled()}
                            >
                                Submit request
                            </button>
                            &nbsp;
                            <button className="btn btn-primary mt-3" type="button" onClick={() => this.closeOfficeRequestModal()}>Cancel</button>
                        </div>
                    </div>
                </Modal>

                {/* ---------- Agreement Modal: ---------- */}
                <Modal
                    isOpen={this.state.agreementModal}
                    onRequestClose={() => this.setState({agreementModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    {
                        this.state.creatingContract ? 
                        <div className='mt-3 text-center text-white'>
                            <p className={this.state.createdContract === 'green' ? 'text-primary' : this.state.createdContract === 'red' ? 'text-danger' : 'text-white'}>Creating Contract</p>
                            <div className={this.state.createdContract === 'green' || this.state.createdContract === 'red' ? 'd-none' : css.CustomerDetails__SendingAgreement}></div>
                            <div className={this.state.createdContract === 'green' || this.state.createdContract === 'red' ? '' : 'd-none'}>
                                <p>Agreement Type: {this.state.newContract.Agreement_Type__c}</p>
                                <p>Continue with sending agreement?</p>
                                <button className="btn btn-primary" disabled={Object.keys(this.state.newContract).length === 0 ? true : false} onClick={() => this.createPandaDocAgreement()}>Send Agreement</button>&nbsp;
                                <button className="btn btn-primary" onClick={() => this.setState({
                                    agreementModal: false, 
                                    sendAgreementDisabled: false,
                                    agreementConfirm: false,
                                    creatingContract: false,
                                    createdContract: '',
                                    createdDoc: '',
                                    docStatus: '',
                                    sentDoc: ''
                                    })}>Close</button>
                            </div>
                        </div>
                        :
                        this.state.agreementConfirm ?
                        <div className='mt-3 text-center text-white'>
                            {/* <p className={this.state.createdContract === 'green' ? 'text-primary' : this.state.createdContract === 'red' ? 'text-danger' : 'text-white'}>Creating Contract</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p> */}
                            <p className={this.state.createdDoc === 'green' ? 'text-primary' : this.state.createdDoc === 'red' ? 'text-danger' : 'text-white'}>Creating PandaDoc Document</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.docStatus === 'green' ? 'text-primary' : this.state.docStatus === 'red' ? 'text-danger' : 'text-white'}>Populating Fields</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.sentDoc === 'green' ? 'text-primary' : this.state.sentDoc === 'red' ? 'text-danger' : 'text-white'}>Sending Document</p>
                            <div className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'd-none' : css.LeadDetails__SendingAgreement}></div>
                            <div className={this.state.createdDoc === 'red' ? '' : 'd-none'}><p>Failed to Create PandaDoc<br/>Please Try Refreshing Page or Contact Sales Support</p></div>
                            <div className={this.state.docStatus === 'red' || this.state.sentDoc === 'red' ? '' : 'd-none'}><p>Failed to Send Document<br/>Please Contact Sales Support to Try Manually Sending Document</p></div>
                            <button className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'btn btn-primary' : 'd-none'} type="button" onClick={() => this.setState({
                                agreementModal: false,
                                agreementConfirm: false,
                                creatingContract: false,
                                createdContract: '',
                                createdDoc: '',
                                docStatus: '',
                                sentDoc: ''
                                })}>Continue
                            </button>
                        </div>
                        :
                        <div className='text-white text-center'>
                            <h2>Create and Send Agreement</h2>
                            <p>Please Select Rep to Add on Agreement</p>
                            <div className='pb-3'>
                                <select value={this.state.repIdForContract} onChange={(event) => this.setState({repIdForContract: event.target.value})}>
                                    <option value=""></option>
                                    {this.state.contractReps.map((option) => <option key={option.value} value={option.id}>{option.value}</option>)}
                                </select>
                            </div>
                            <button className="btn btn-primary" onClick={() => this.createContract()}>Send Agreement</button>&nbsp;
                            <button className="btn btn-primary" onClick={() => this.setState({agreementModal: false, sendAgreementDisabled: false})}>Close</button>
                        </div>
                    }
                </Modal>

                {/* ---------- Cancel Survey Modal: ---------- */}
                <Modal
                    isOpen={this.state.cancelSurveyModal}
                    onRequestClose={() => this.setState({cancelSurveyModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="mt-3 text-center text-white">
                        <div className='text-right'>
                            <span className="mx-2 text-right cursor-pointer">
                                <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({cancelSurveyModal: false})} />
                            </span>
                        </div>
                        <h3 className='pb-2'>Cancel Upcoming Surveys</h3>
                        {this.state.scheduledSurveys.map(survey => 
                            <div>
                                <p className='pt-4'>{survey.Name}</p>
                                <p>{formatShortDate(survey.Date__c)}  {survey.Start_Time__c ? moment(survey.Start_Time__c, 'HH:mm').format('HH:mm A') : ''}</p>
                                <button className="btn btn-primary" type="button" disabled={this.state.disableCancelSurvey} onClick={() => this.cancelSurvey(survey.Id)}>Cancel Survey</button>
                                {
                                    this.state.errorCancelSurvey ?
                                    <div>
                                        <p className='pt-2 pb-2 text-uppercase fw-bold text-danger'>Failed to cancel survey</p>
                                    </div>
                                    :
                                    ''
                                }
                            </div>
                        )}
                    </div>
                </Modal>

                {/* ---------- Install Error Modal: ---------- */}
                <Modal
                    isOpen={this.state.installErrorModal}
                    onRequestClose={() => this.setState({installErrorModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="mt-3 text-center text-white">
                        <div className='text-right'>
                            <span className="mx-2 text-right cursor-pointer">
                                <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({installErrorModal: false})} />
                            </span>
                        </div>
                        <h5 className='text-uppercase py-4'>Error: {this.state.installErrorNotes}</h5>
                        <button className="btn btn-primary" type="button" onClick={() => this.setState({installErrorModal: false})}>Close</button>&nbsp;
                    </div>
                </Modal>

                {/* ---------- Accept Retention Modal: ---------- */}
                <Modal
                    isOpen={this.state.retentionModal}
                    onRequestClose={() => this.setState({retentionModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="mt-3 text-center text-white">
                        <h3>Retention</h3>
                        <h5 className='text-uppercase py-4'>{this.state.retentionNotes}</h5>
                        <button className="btn btn-primary" type="button" onClick={() => this.setState({retentionModal: false})}>Close</button>&nbsp;
                    </div>
                </Modal>

                {/* ---------- Cancel Pending Modal: ---------- */}
                <Modal
                    isOpen={this.state.isCancelPendingModalOpen}
                    onRequestClose={() => this.setState({
                        isCancelPendingModalOpen: false,
                        reason: '',
                        subReason: '',
                        reasonSpecific: ''
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            maxHeight: 'calc(100vh - 2rem)', // 20vh more than original
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Cancel Pending</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                                isCancelPendingModalOpen: false,
                                reason: '',
                                subReason: '',
                                reasonSpecific: ''
                            })} />
                        </span>
                    </div>

                    <div className="mt-3 text-white">
                        <label htmlFor="reason">Reason *</label>
                        <select className="form-control"  onChange={(event) => {this.setState({reason: event.target.value}); if(!this.state.cancelSubReasonsMap[this.state.reason]?.includes(this.state.subReason)){this.setState({subReason: ""})}}}>
                            <option value=""></option>
                            { this.state.cancelReasons.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>

                    <div className={this.state.cancelSubReasonsMap[this.state.reason]?.length > 0 ? "mt-3 text-white" : "d-none"}>
                        <label htmlFor="reason">Sub Reason *</label>
                        <select className="form-control"  value={this.state.subReason} onChange={(event) => this.setState({subReason: event.target.value})}>
                            <option value=""></option>
                            { this.state.cancelSubReasonsMap[this.state.reason]?.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>

                    <div className="mt-3 text-white">
                        <label htmlFor="revNotes">Reason (Specific):</label>
                        <textarea className="form-control" rows={2} maxLength={255}  onChange={(event) => this.setState({reasonSpecific: event.target.value})}></textarea>
                    </div>

                    <div className="mt-3 text-right text-white">
                        <button className="btn btn-primary" type="button" 
                            disabled={this.state.disableCancelPending || !this.state.reason || (this.state.cancelSubReasonsMap[this.state.reason]?.length > 0 && !this.state.subReason)} 
                            onClick={() => this.createRetentionRecord()}>
                                Create Retention
                        </button>
                        &nbsp;
                        <button className="btn btn-primary" type="button" 
                            disabled={this.state.disableCancelPending} 
                            onClick={() => this.setState({isCancelPendingModalOpen: false, reason: '', subReason: '', reasonSpecific: ''})}>
                                Cancel
                        </button>
                    </div>
                </Modal>

                {/* ---------- Cancel Pending Modal: ---------- */}
                <Modal
                    isOpen={this.state.showUnfinishedSurvey}
                    onRequestClose={() => this.setState({
                        showUnfinishedSurvey: false
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Error Booking Survey Session</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                                showUnfinishedSurvey: false
                            })} />
                        </span>
                    </div>

                    <div className="mt-3 text-white">
                        <p>A survey session is already scheduled for this customer that has not been completed yet.</p>
                        <p>Please reach out to Sales Support if further information is needed.</p>
                    </div>

                    <div className="mt-3 text-right text-white">
                        <button className="btn btn-primary" type="button" disabled={this.state.disableCancelPending} onClick={() => this.setState({showUnfinishedSurvey: false})}>Close</button>
                    </div>
                </Modal>

                {/* ---------- HoldResolvedModal: ---------- */}
                <Modal
                    isOpen={this.state.holdResolvedModalOpen}
                    onRequestClose={() => this.closeHoldResolved()}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Text Out Hold Recheck</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.closeHoldResolved()} />
                        </span>
                    </div>

                    <div className={this.state.holdResolvedSuccessful !== true ? "" : "d-none"}>
                        <div className="mt-3 text-white">
                            <p>Please confirm that you want the office to re-check the uploaded documents and confirm the sold text out.</p>
                        </div>

                        <div className="mt-3 text-right text-white">
                            <button className="btn btn-primary" type="button" disabled={this.state.holdResolvedButtonsDisabled} onClick={() => this.confirmHoldResolved()}>Confirm</button>
                            &nbsp;
                            <button className="btn btn-primary" type="button" onClick={() => this.closeHoldResolved()}>Cancel</button>
                        </div>
                    </div>

                    <div className={this.state.holdResolvedSuccessful === true ? "" : "d-none"}>
                        <div className="mt-3 text-white">
                            <p>Office has been notified to re-check the uploaded documents and confirm the sold text out.</p>
                        </div>
                        <div className="mt-3 text-right text-white">
                            <button className="btn btn-primary" type="button" onClick={() => this.closeHoldResolved()}>Close</button>
                        </div>
                    </div>
                </Modal>

                {/* ---------- Rep Action Resolved Modal: ---------- */}
                <Modal
                    isOpen={this.state.repActionResolvedModalOpen}
                    onRequestClose={() => this.closeRepActionResolved()}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            maxHeight: 'calc(100vh - 2rem)', // 20vh more than original
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Rep Action Resolved</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.closeRepActionResolved()} />
                        </span>
                    </div>

                    <div className={this.state.actionRequired.some(action => action.isRepActionRequired) ? "mt-3 text-white" : "d-none"}>
                        <b>Action Resolved:</b> {this.state.actionRequired.filter(action => action.isRepActionRequired).map(action => action.name).join(', ')}
                    </div>

                    <div className="mt-3 text-white">
                        <label htmlFor="repNotesToAccountManager">Notes to Account Manager *</label>
                        <textarea className="form-control" rows={4} maxLength={255}  onChange={(event) => this.setState({repNotesToAccountManager: event.target.value})}></textarea>
                    </div>

                    <div className="mt-3 text-right text-white">
                        <button className="btn btn-primary" type="button" 
                            disabled={!this.state.repNotesToAccountManager || this.state.repActionResolvedButtonDisabled} 
                            onClick={() => this.resolveRepAction()}>
                                Request Review
                        </button>
                        &nbsp;
                        <button className="btn btn-primary" type="button" 
                            onClick={() => this.closeRepActionResolved()}>
                                Cancel
                        </button>
                    </div>
                </Modal>
            </div>
        </>
        return (
            <div>
                {
                    this.state.shouldShowCalendar ? 
                    <SurveyCalendar onShouldShowCalendar={(val) => this.handleShouldShowCalendar(val)} oppId={this.state.opportunity.Id} /> 
                    : 
                        this.state.shouldShowInstallCalendar ? 
                        <InstallCalendar onShouldShowCalendar={(val) => this.handleShouldShowCalendar(val)} oppId={this.state.opportunity.Id} numDays={this.state.numInstallDays} texasLocation={this.state.texasLocation} /> 
                        : viewCustomer
                }
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(CustomerDetails);
